
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models'
export type * from './prismaNamespace'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  ReviewerCredential: 'ReviewerCredential',
  ReviewerAccountAudit: 'ReviewerAccountAudit',
  UserEntitlementGrant: 'UserEntitlementGrant',
  CourseTopicCompletion: 'CourseTopicCompletion',
  CourseModuleAccess: 'CourseModuleAccess',
  CourseTrackFollow: 'CourseTrackFollow',
  CourseExerciseAttempt: 'CourseExerciseAttempt',
  StripeSubscription: 'StripeSubscription',
  StripeEvent: 'StripeEvent',
  FiscalTransaction: 'FiscalTransaction',
  StripeCheckoutReservation: 'StripeCheckoutReservation',
  FiscalTaxIdLock: 'FiscalTaxIdLock',
  CreditAccount: 'CreditAccount',
  CreditPurchase: 'CreditPurchase',
  CreditLedgerEntry: 'CreditLedgerEntry',
  AiUsageRecord: 'AiUsageRecord',
  AiReportDefinition: 'AiReportDefinition',
  AiReportRun: 'AiReportRun',
  ContactSubmission: 'ContactSubmission',
  UserAiSettings: 'UserAiSettings',
  ChatConversation: 'ChatConversation',
  ChatMessage: 'ChatMessage',
  VerificationToken: 'VerificationToken',
  FeatureFlags: 'FeatureFlags',
  FeatureFlagUser: 'FeatureFlagUser',
  CatalogSavedSearch: 'CatalogSavedSearch',
  UserPortfolio: 'UserPortfolio',
  UserPortfolioTransaction: 'UserPortfolioTransaction',
  UserPortfolioImportProvenance: 'UserPortfolioImportProvenance',
  UserPortfolioHoldingSnapshot: 'UserPortfolioHoldingSnapshot',
  UserPortfolioSummarySnapshot: 'UserPortfolioSummarySnapshot',
  UserPortfolioExposureSnapshot: 'UserPortfolioExposureSnapshot',
  UserPortfolioExposureSnapshotItem: 'UserPortfolioExposureSnapshotItem',
  UserPortfolioExposureSnapshotValue: 'UserPortfolioExposureSnapshotValue',
  UserPortfolioPatrimonyHistory: 'UserPortfolioPatrimonyHistory',
  UserPortfolioPatrimonyTypeHistory: 'UserPortfolioPatrimonyTypeHistory',
  UserPortfolioPatrimonyCategoryHistory: 'UserPortfolioPatrimonyCategoryHistory',
  UserPortfolioPatrimonyAssetHistory: 'UserPortfolioPatrimonyAssetHistory',
  UserPortfolioInvestmentJournal: 'UserPortfolioInvestmentJournal',
  UserPortfolioInvestmentJournalMonthly: 'UserPortfolioInvestmentJournalMonthly',
  UserPortfolioCapitalPreservationSnapshot: 'UserPortfolioCapitalPreservationSnapshot',
  UserPortfolioPositionHistory: 'UserPortfolioPositionHistory',
  UserPortfolioIncomeHistory: 'UserPortfolioIncomeHistory',
  UserPortfolioProcessingDiagnostic: 'UserPortfolioProcessingDiagnostic',
  UserPortfolioImportSession: 'UserPortfolioImportSession',
  UserPortfolioImportSessionItem: 'UserPortfolioImportSessionItem',
  InstrumentType: 'InstrumentType',
  Instrument: 'Instrument',
  TreasuryQuote: 'TreasuryQuote',
  FixedIncomeCashFlowSchedule: 'FixedIncomeCashFlowSchedule',
  FixedIncomeCashFlow: 'FixedIncomeCashFlow',
  TreasuryFeeRule: 'TreasuryFeeRule',
  UserPortfolioExpense: 'UserPortfolioExpense',
  FixedIncomeScreenerSnapshot: 'FixedIncomeScreenerSnapshot',
  InstrumentTradingIdentity: 'InstrumentTradingIdentity',
  InstrumentCnpj: 'InstrumentCnpj',
  CvmFund: 'CvmFund',
  CvmFundClass: 'CvmFundClass',
  CvmFundSubclass: 'CvmFundSubclass',
  CvmFiiInfMensalGeral: 'CvmFiiInfMensalGeral',
  CvmFiiInfMensalAtivoPassivo: 'CvmFiiInfMensalAtivoPassivo',
  CvmFiiInfMensalComplemento: 'CvmFiiInfMensalComplemento',
  CvmFiiInfTrimestralAlienacaoImovel: 'CvmFiiInfTrimestralAlienacaoImovel',
  CvmFiiInfTrimestralAlienacaoTerreno: 'CvmFiiInfTrimestralAlienacaoTerreno',
  CvmFiiInfTrimestralAquisicaoImovel: 'CvmFiiInfTrimestralAquisicaoImovel',
  CvmFiiInfTrimestralAquisicaoTerreno: 'CvmFiiInfTrimestralAquisicaoTerreno',
  CvmFiiInfTrimestralAtivo: 'CvmFiiInfTrimestralAtivo',
  CvmFiiInfTrimestralAtivoGarantiaRentabilidade: 'CvmFiiInfTrimestralAtivoGarantiaRentabilidade',
  CvmFiiInfTrimestralComplemento: 'CvmFiiInfTrimestralComplemento',
  CvmFiiInfTrimestralDireito: 'CvmFiiInfTrimestralDireito',
  CvmFiiInfTrimestralGeral: 'CvmFiiInfTrimestralGeral',
  CvmFiiInfTrimestralImovel: 'CvmFiiInfTrimestralImovel',
  CvmFiiInfTrimestralImovelDesempenho: 'CvmFiiInfTrimestralImovelDesempenho',
  CvmFiiInfTrimestralImovelRendaAcabadoContrato: 'CvmFiiInfTrimestralImovelRendaAcabadoContrato',
  CvmFiiInfTrimestralImovelRendaAcabadoInquilino: 'CvmFiiInfTrimestralImovelRendaAcabadoInquilino',
  CvmFiiInfTrimestralRentabilidadeEfetiva: 'CvmFiiInfTrimestralRentabilidadeEfetiva',
  CvmFiiInfTrimestralResultadoContabilFinanceiro: 'CvmFiiInfTrimestralResultadoContabilFinanceiro',
  CvmFiiInfTrimestralTerreno: 'CvmFiiInfTrimestralTerreno',
  CvmFiiInfAnualAtivoAdquirido: 'CvmFiiInfAnualAtivoAdquirido',
  CvmFiiInfAnualAtivoTransacao: 'CvmFiiInfAnualAtivoTransacao',
  CvmFiiInfAnualAtivoValorContabil: 'CvmFiiInfAnualAtivoValorContabil',
  CvmFiiInfAnualComplemento: 'CvmFiiInfAnualComplemento',
  CvmFiiInfAnualDiretorResponsavel: 'CvmFiiInfAnualDiretorResponsavel',
  CvmFiiInfAnualDistribuicaoCotistas: 'CvmFiiInfAnualDistribuicaoCotistas',
  CvmFiiInfAnualExperienciaProfissional: 'CvmFiiInfAnualExperienciaProfissional',
  CvmFiiInfAnualGeral: 'CvmFiiInfAnualGeral',
  CvmFiiInfAnualPrestadorServico: 'CvmFiiInfAnualPrestadorServico',
  CvmFiiInfAnualProcesso: 'CvmFiiInfAnualProcesso',
  CvmFiiInfAnualProcessoSemelhante: 'CvmFiiInfAnualProcessoSemelhante',
  CvmFiiInfAnualRepresentanteCotista: 'CvmFiiInfAnualRepresentanteCotista',
  CvmFiiInfAnualRepresentanteCotistaFundo: 'CvmFiiInfAnualRepresentanteCotistaFundo',
  CvmFiiDfin: 'CvmFiiDfin',
  CvmFidcInfMensalTabIii: 'CvmFidcInfMensalTabIii',
  CvmFidcInfMensalTabIi: 'CvmFidcInfMensalTabIi',
  CvmFidcInfMensalTabIv: 'CvmFidcInfMensalTabIv',
  CvmFidcInfMensalTabIx: 'CvmFidcInfMensalTabIx',
  CvmFidcInfMensalTabI: 'CvmFidcInfMensalTabI',
  CvmFidcInfMensalTabVii: 'CvmFidcInfMensalTabVii',
  CvmFidcInfMensalTabViii: 'CvmFidcInfMensalTabViii',
  CvmFidcInfMensalTabVi: 'CvmFidcInfMensalTabVi',
  CvmFidcInfMensalTabV: 'CvmFidcInfMensalTabV',
  CvmFidcInfMensalTabX11: 'CvmFidcInfMensalTabX11',
  CvmFidcInfMensalTabX1: 'CvmFidcInfMensalTabX1',
  CvmFidcInfMensalTabX: 'CvmFidcInfMensalTabX',
  CvmFidcInfMensalTabX2: 'CvmFidcInfMensalTabX2',
  CvmFidcInfMensalTabX3: 'CvmFidcInfMensalTabX3',
  CvmFidcInfMensalTabX4: 'CvmFidcInfMensalTabX4',
  CvmFidcInfMensalTabX5: 'CvmFidcInfMensalTabX5',
  CvmFidcInfMensalTabX6: 'CvmFidcInfMensalTabX6',
  CvmFidcInfMensalTabX7: 'CvmFidcInfMensalTabX7',
  CvmFiagroInfMensalGeral: 'CvmFiagroInfMensalGeral',
  CvmFiagroInfMensalSubclasse: 'CvmFiagroInfMensalSubclasse',
  CvmFipInfQuadrimestral: 'CvmFipInfQuadrimestral',
  CvmFieMedidasMes: 'CvmFieMedidasMes',
  Report: 'Report',
  Summary: 'Summary',
  SummaryFII: 'SummaryFII',
  PriceHistory: 'PriceHistory',
  PriceHistoryAdjusted: 'PriceHistoryAdjusted',
  MarketSeries: 'MarketSeries',
  VpSnapshot: 'VpSnapshot',
  LiquiditySnapshot: 'LiquiditySnapshot',
  ScreenerSnapshot: 'ScreenerSnapshot',
  ScreenerSnapshotPosition: 'ScreenerSnapshotPosition',
  ScreenerSnapshotRelated: 'ScreenerSnapshotRelated',
  AssetExposureDimension: 'AssetExposureDimension',
  AssetExposureValue: 'AssetExposureValue',
  AssetExposureProfile: 'AssetExposureProfile',
  AssetExposureProfileItem: 'AssetExposureProfileItem',
  AssetExposureProfileValue: 'AssetExposureProfileValue',
  Dividend: 'Dividend',
  DividendEventSnapshot: 'DividendEventSnapshot',
  CorporateAction: 'CorporateAction',
  InstrumentSyncState: 'InstrumentSyncState',
  MarketDataUrlState: 'MarketDataUrlState',
  PipelineRun: 'PipelineRun',
  PipelineStepRun: 'PipelineStepRun',
  EmailPreference: 'EmailPreference',
  EmailProcessingStatus: 'EmailProcessingStatus',
  EmailCampaign: 'EmailCampaign',
  EmailCampaignStatus: 'EmailCampaignStatus',
  DmarcImporterState: 'DmarcImporterState',
  DmarcAggregateReport: 'DmarcAggregateReport',
  DmarcAggregateRecord: 'DmarcAggregateRecord',
  DmarcForensicReport: 'DmarcForensicReport',
  TlsRptReport: 'TlsRptReport',
  FblReport: 'FblReport',
  McpOAuthClient: 'McpOAuthClient',
  McpGrant: 'McpGrant',
  McpAuthCode: 'McpAuthCode',
  McpRefreshToken: 'McpRefreshToken',
  McpUsageLog: 'McpUsageLog'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
} as const

export type AccountScalarFieldEnum = (typeof AccountScalarFieldEnum)[keyof typeof AccountScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const UserScalarFieldEnum = {
  id: 'id',
  isActive: 'isActive',
  accessExpiresAt: 'accessExpiresAt',
  stripeCustomerId: 'stripeCustomerId',
  trialUsedAt: 'trialUsedAt',
  lastSelectedPortfolioId: 'lastSelectedPortfolioId',
  lastPanelVisitAt: 'lastPanelVisitAt',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  createdAt: 'createdAt',
  role: 'role'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const ReviewerCredentialScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  passwordHash: 'passwordHash',
  enabled: 'enabled',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastUsedAt: 'lastUsedAt'
} as const

export type ReviewerCredentialScalarFieldEnum = (typeof ReviewerCredentialScalarFieldEnum)[keyof typeof ReviewerCredentialScalarFieldEnum]


export const ReviewerAccountAuditScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  action: 'action',
  reason: 'reason',
  reference: 'reference',
  operator: 'operator',
  createdAt: 'createdAt'
} as const

export type ReviewerAccountAuditScalarFieldEnum = (typeof ReviewerAccountAuditScalarFieldEnum)[keyof typeof ReviewerAccountAuditScalarFieldEnum]


export const UserEntitlementGrantScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  entitlement: 'entitlement',
  startsAt: 'startsAt',
  expiresAt: 'expiresAt',
  revokedAt: 'revokedAt',
  reason: 'reason',
  reference: 'reference',
  idempotencyKey: 'idempotencyKey',
  grantedBy: 'grantedBy',
  revokedBy: 'revokedBy',
  revocationReason: 'revocationReason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserEntitlementGrantScalarFieldEnum = (typeof UserEntitlementGrantScalarFieldEnum)[keyof typeof UserEntitlementGrantScalarFieldEnum]


export const CourseTopicCompletionScalarFieldEnum = {
  userId: 'userId',
  courseId: 'courseId',
  topicId: 'topicId',
  completedAt: 'completedAt'
} as const

export type CourseTopicCompletionScalarFieldEnum = (typeof CourseTopicCompletionScalarFieldEnum)[keyof typeof CourseTopicCompletionScalarFieldEnum]


export const CourseModuleAccessScalarFieldEnum = {
  userId: 'userId',
  courseId: 'courseId',
  moduleId: 'moduleId',
  lastAccessedTrackId: 'lastAccessedTrackId',
  lastAccessedTopicId: 'lastAccessedTopicId',
  lastAccessedAt: 'lastAccessedAt'
} as const

export type CourseModuleAccessScalarFieldEnum = (typeof CourseModuleAccessScalarFieldEnum)[keyof typeof CourseModuleAccessScalarFieldEnum]


export const CourseTrackFollowScalarFieldEnum = {
  userId: 'userId',
  trackId: 'trackId',
  followedAt: 'followedAt',
  lastAccessedAt: 'lastAccessedAt'
} as const

export type CourseTrackFollowScalarFieldEnum = (typeof CourseTrackFollowScalarFieldEnum)[keyof typeof CourseTrackFollowScalarFieldEnum]


export const CourseExerciseAttemptScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  courseId: 'courseId',
  topicId: 'topicId',
  contentVersion: 'contentVersion',
  dslVersion: 'dslVersion',
  answers: 'answers',
  questionResults: 'questionResults',
  status: 'status',
  pointsEarned: 'pointsEarned',
  pointsPossible: 'pointsPossible',
  score: 'score',
  passed: 'passed',
  createdAt: 'createdAt'
} as const

export type CourseExerciseAttemptScalarFieldEnum = (typeof CourseExerciseAttemptScalarFieldEnum)[keyof typeof CourseExerciseAttemptScalarFieldEnum]


export const StripeSubscriptionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  stripeSubscriptionId: 'stripeSubscriptionId',
  stripeCustomerId: 'stripeCustomerId',
  stripePriceId: 'stripePriceId',
  lookupKey: 'lookupKey',
  status: 'status',
  billingInterval: 'billingInterval',
  trialStart: 'trialStart',
  trialEnd: 'trialEnd',
  currentPeriodStart: 'currentPeriodStart',
  currentPeriodEnd: 'currentPeriodEnd',
  cancelAtPeriodEnd: 'cancelAtPeriodEnd',
  cancelAt: 'cancelAt',
  canceledAt: 'canceledAt',
  nextMonthlyGrantAt: 'nextMonthlyGrantAt',
  annualGrantAnchor: 'annualGrantAnchor',
  annualGrantMonthIndex: 'annualGrantMonthIndex',
  lastStripeEventCreatedAt: 'lastStripeEventCreatedAt',
  lastStripeEventId: 'lastStripeEventId',
  isCurrent: 'isCurrent',
  currentForUserId: 'currentForUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StripeSubscriptionScalarFieldEnum = (typeof StripeSubscriptionScalarFieldEnum)[keyof typeof StripeSubscriptionScalarFieldEnum]


export const StripeEventScalarFieldEnum = {
  id: 'id',
  stripeEventId: 'stripeEventId',
  type: 'type',
  objectId: 'objectId',
  status: 'status',
  attempts: 'attempts',
  errorMessage: 'errorMessage',
  receivedAt: 'receivedAt',
  processedAt: 'processedAt',
  updatedAt: 'updatedAt',
  claimToken: 'claimToken',
  claimedAt: 'claimedAt',
  userId: 'userId'
} as const

export type StripeEventScalarFieldEnum = (typeof StripeEventScalarFieldEnum)[keyof typeof StripeEventScalarFieldEnum]


export const FiscalTransactionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  operation: 'operation',
  serviceKind: 'serviceKind',
  status: 'status',
  sourceKey: 'sourceKey',
  sourceEventId: 'sourceEventId',
  invoiceId: 'invoiceId',
  subscriptionId: 'subscriptionId',
  paymentIntentId: 'paymentIntentId',
  checkoutSessionId: 'checkoutSessionId',
  creditPurchaseId: 'creditPurchaseId',
  refundId: 'refundId',
  originalTransactionId: 'originalTransactionId',
  amountCents: 'amountCents',
  currency: 'currency',
  effectiveAt: 'effectiveAt',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  customerSnapshot: 'customerSnapshot',
  claimToken: 'claimToken',
  claimedAt: 'claimedAt',
  nextAttemptAt: 'nextAttemptAt',
  attemptCount: 'attemptCount',
  lastError: 'lastError',
  providerReference: 'providerReference',
  documentNumber: 'documentNumber',
  eventReference: 'eventReference',
  dpsSeries: 'dpsSeries',
  dpsNumber: 'dpsNumber',
  dpsId: 'dpsId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FiscalTransactionScalarFieldEnum = (typeof FiscalTransactionScalarFieldEnum)[keyof typeof FiscalTransactionScalarFieldEnum]


export const StripeCheckoutReservationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  status: 'status',
  leaseExpiresAt: 'leaseExpiresAt',
  expiresAt: 'expiresAt',
  stripeSessionId: 'stripeSessionId',
  checkoutUrl: 'checkoutUrl',
  billingPeriod: 'billingPeriod',
  lookupKey: 'lookupKey',
  claimToken: 'claimToken',
  stripeIdempotencyKey: 'stripeIdempotencyKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type StripeCheckoutReservationScalarFieldEnum = (typeof StripeCheckoutReservationScalarFieldEnum)[keyof typeof StripeCheckoutReservationScalarFieldEnum]


export const FiscalTaxIdLockScalarFieldEnum = {
  customerId: 'customerId',
  owner: 'owner',
  leaseUntil: 'leaseUntil'
} as const

export type FiscalTaxIdLockScalarFieldEnum = (typeof FiscalTaxIdLockScalarFieldEnum)[keyof typeof FiscalTaxIdLockScalarFieldEnum]


export const CreditAccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  monthlyCents: 'monthlyCents',
  purchasedCents: 'purchasedCents',
  monthlyExpiresAt: 'monthlyExpiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CreditAccountScalarFieldEnum = (typeof CreditAccountScalarFieldEnum)[keyof typeof CreditAccountScalarFieldEnum]


export const CreditPurchaseScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  checkoutIdempotencyKey: 'checkoutIdempotencyKey',
  checkoutExpiresAt: 'checkoutExpiresAt',
  checkoutPixEnabled: 'checkoutPixEnabled',
  checkoutBaseUrl: 'checkoutBaseUrl',
  stripeCustomerId: 'stripeCustomerId',
  stripeCheckoutSessionId: 'stripeCheckoutSessionId',
  checkoutUrl: 'checkoutUrl',
  stripePaymentIntentId: 'stripePaymentIntentId',
  stripePriceId: 'stripePriceId',
  amountCents: 'amountCents',
  creditsGrantedCents: 'creditsGrantedCents',
  remainingCents: 'remainingCents',
  currency: 'currency',
  status: 'status',
  paidAt: 'paidAt',
  refundedAt: 'refundedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CreditPurchaseScalarFieldEnum = (typeof CreditPurchaseScalarFieldEnum)[keyof typeof CreditPurchaseScalarFieldEnum]


export const CreditLedgerEntryScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  source: 'source',
  amountCents: 'amountCents',
  balanceAfterCents: 'balanceAfterCents',
  origin: 'origin',
  idempotencyKey: 'idempotencyKey',
  expiresAt: 'expiresAt',
  metadata: 'metadata',
  creditPurchaseId: 'creditPurchaseId',
  createdAt: 'createdAt'
} as const

export type CreditLedgerEntryScalarFieldEnum = (typeof CreditLedgerEntryScalarFieldEnum)[keyof typeof CreditLedgerEntryScalarFieldEnum]


export const AiUsageRecordScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  conversationId: 'conversationId',
  modelId: 'modelId',
  provider: 'provider',
  openrouterRequestId: 'openrouterRequestId',
  inputTokens: 'inputTokens',
  outputTokens: 'outputTokens',
  cachedInputTokens: 'cachedInputTokens',
  cacheWriteTokens: 'cacheWriteTokens',
  costUsd: 'costUsd',
  exchangeRate: 'exchangeRate',
  exchangeRateDate: 'exchangeRateDate',
  costBrl: 'costBrl',
  multiplier: 'multiplier',
  chargedCents: 'chargedCents',
  chargedFromMonthlyCents: 'chargedFromMonthlyCents',
  chargedFromPurchasedCents: 'chargedFromPurchasedCents',
  absorbedCents: 'absorbedCents',
  source: 'source',
  status: 'status',
  idempotencyKey: 'idempotencyKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AiUsageRecordScalarFieldEnum = (typeof AiUsageRecordScalarFieldEnum)[keyof typeof AiUsageRecordScalarFieldEnum]


export const AiReportDefinitionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  prompt: 'prompt',
  weekdaysMask: 'weekdaysMask',
  enabled: 'enabled',
  lastRunAt: 'lastRunAt',
  nextRunAt: 'nextRunAt',
  lastStatus: 'lastStatus',
  lastErrorCode: 'lastErrorCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AiReportDefinitionScalarFieldEnum = (typeof AiReportDefinitionScalarFieldEnum)[keyof typeof AiReportDefinitionScalarFieldEnum]


export const AiReportRunScalarFieldEnum = {
  id: 'id',
  reportDefinitionId: 'reportDefinitionId',
  scheduledFor: 'scheduledFor',
  runType: 'runType',
  status: 'status',
  promptUsed: 'promptUsed',
  effectiveDate: 'effectiveDate',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  modelId: 'modelId',
  openrouterRequestId: 'openrouterRequestId',
  usageRecordId: 'usageRecordId',
  chargedCents: 'chargedCents',
  subject: 'subject',
  markdown: 'markdown',
  documentHtml: 'documentHtml',
  emailHtml: 'emailHtml',
  emailMessageId: 'emailMessageId',
  errorCode: 'errorCode',
  errorMessage: 'errorMessage',
  retentionUntil: 'retentionUntil',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AiReportRunScalarFieldEnum = (typeof AiReportRunScalarFieldEnum)[keyof typeof AiReportRunScalarFieldEnum]


export const ContactSubmissionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  subject: 'subject',
  message: 'message',
  type: 'type',
  ipHash: 'ipHash',
  userId: 'userId',
  createdAt: 'createdAt'
} as const

export type ContactSubmissionScalarFieldEnum = (typeof ContactSubmissionScalarFieldEnum)[keyof typeof ContactSubmissionScalarFieldEnum]


export const UserAiSettingsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  defaultAiModelId: 'defaultAiModelId',
  defaultThinkingEffort: 'defaultThinkingEffort',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserAiSettingsScalarFieldEnum = (typeof UserAiSettingsScalarFieldEnum)[keyof typeof UserAiSettingsScalarFieldEnum]


export const ChatConversationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  title: 'title',
  thinkingEffort: 'thinkingEffort',
  totalInputTokens: 'totalInputTokens',
  totalOutputTokens: 'totalOutputTokens',
  totalCachedInputTokens: 'totalCachedInputTokens',
  totalCacheWriteTokens: 'totalCacheWriteTokens',
  totalCostUsd: 'totalCostUsd',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ChatConversationScalarFieldEnum = (typeof ChatConversationScalarFieldEnum)[keyof typeof ChatConversationScalarFieldEnum]


export const ChatMessageScalarFieldEnum = {
  id: 'id',
  conversationId: 'conversationId',
  role: 'role',
  status: 'status',
  content: 'content',
  modelId: 'modelId',
  renderers: 'renderers',
  createdAt: 'createdAt'
} as const

export type ChatMessageScalarFieldEnum = (typeof ChatMessageScalarFieldEnum)[keyof typeof ChatMessageScalarFieldEnum]


export const VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
} as const

export type VerificationTokenScalarFieldEnum = (typeof VerificationTokenScalarFieldEnum)[keyof typeof VerificationTokenScalarFieldEnum]


export const FeatureFlagsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  isEnabled: 'isEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeatureFlagsScalarFieldEnum = (typeof FeatureFlagsScalarFieldEnum)[keyof typeof FeatureFlagsScalarFieldEnum]


export const FeatureFlagUserScalarFieldEnum = {
  featureFlagId: 'featureFlagId',
  userId: 'userId',
  createdAt: 'createdAt'
} as const

export type FeatureFlagUserScalarFieldEnum = (typeof FeatureFlagUserScalarFieldEnum)[keyof typeof FeatureFlagUserScalarFieldEnum]


export const CatalogSavedSearchScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  description: 'description',
  catalogPath: 'catalogPath',
  queryString: 'queryString',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CatalogSavedSearchScalarFieldEnum = (typeof CatalogSavedSearchScalarFieldEnum)[keyof typeof CatalogSavedSearchScalarFieldEnum]


export const UserPortfolioScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  description: 'description',
  isPrimary: 'isPrimary',
  isPublished: 'isPublished',
  visibility: 'visibility',
  publicSlug: 'publicSlug',
  mode: 'mode',
  currencyCode: 'currencyCode',
  lastImportedAt: 'lastImportedAt',
  lastImportDescription: 'lastImportDescription',
  processingStatus: 'processingStatus',
  processingError: 'processingError',
  processingMessage: 'processingMessage',
  lastProcessedAt: 'lastProcessedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioScalarFieldEnum = (typeof UserPortfolioScalarFieldEnum)[keyof typeof UserPortfolioScalarFieldEnum]


export const UserPortfolioTransactionScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  instrumentId: 'instrumentId',
  assetCategory: 'assetCategory',
  assetCode: 'assetCode',
  assetName: 'assetName',
  isinCode: 'isinCode',
  cnpj: 'cnpj',
  transactionType: 'transactionType',
  source: 'source',
  occurredAt: 'occurredAt',
  settledAt: 'settledAt',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  grossAmount: 'grossAmount',
  netAmount: 'netAmount',
  feesAmount: 'feesAmount',
  taxesAmount: 'taxesAmount',
  isReinvestment: 'isReinvestment',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type UserPortfolioTransactionScalarFieldEnum = (typeof UserPortfolioTransactionScalarFieldEnum)[keyof typeof UserPortfolioTransactionScalarFieldEnum]


export const UserPortfolioImportProvenanceScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  transactionId: 'transactionId',
  sourceIdentity: 'sourceIdentity',
  sourceSnapshot: 'sourceSnapshot',
  materializedSnapshot: 'materializedSnapshot',
  createdAt: 'createdAt'
} as const

export type UserPortfolioImportProvenanceScalarFieldEnum = (typeof UserPortfolioImportProvenanceScalarFieldEnum)[keyof typeof UserPortfolioImportProvenanceScalarFieldEnum]


export const UserPortfolioHoldingSnapshotScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  instrumentId: 'instrumentId',
  assetCategory: 'assetCategory',
  assetCode: 'assetCode',
  assetName: 'assetName',
  quantity: 'quantity',
  averagePrice: 'averagePrice',
  averagePriceAdjusted: 'averagePriceAdjusted',
  investedAmount: 'investedAmount',
  realizedDividends: 'realizedDividends',
  realizedAmortization: 'realizedAmortization',
  currentPrice: 'currentPrice',
  marketValue: 'marketValue',
  portfolioPercent: 'portfolioPercent',
  priceDate: 'priceDate',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioHoldingSnapshotScalarFieldEnum = (typeof UserPortfolioHoldingSnapshotScalarFieldEnum)[keyof typeof UserPortfolioHoldingSnapshotScalarFieldEnum]


export const UserPortfolioSummarySnapshotScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  instrumentTypeId: 'instrumentTypeId',
  fundTypeSymbol: 'fundTypeSymbol',
  fundTypeName: 'fundTypeName',
  supportedAssetCount: 'supportedAssetCount',
  pricedAssetCount: 'pricedAssetCount',
  totalMarketValue: 'totalMarketValue',
  investedAmount: 'investedAmount',
  returnAmount: 'returnAmount',
  returnPercent: 'returnPercent',
  income12mAmount: 'income12mAmount',
  income12mPaidAmount: 'income12mPaidAmount',
  income12mForecastAmount: 'income12mForecastAmount',
  income12mMonthlyAverage: 'income12mMonthlyAverage',
  variationIncome12mAmount: 'variationIncome12mAmount',
  variationIncome12mPercent: 'variationIncome12mPercent',
  dyIncome12mAmount: 'dyIncome12mAmount',
  dyPercent: 'dyPercent',
  yocPercent: 'yocPercent',
  paidThisMonth: 'paidThisMonth',
  forecastThisMonth: 'forecastThisMonth',
  custodyFeeAmount: 'custodyFeeAmount',
  monthsWithIncome12m: 'monthsWithIncome12m',
  topIncomeAssets12m: 'topIncomeAssets12m',
  topPositions: 'topPositions',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioSummarySnapshotScalarFieldEnum = (typeof UserPortfolioSummarySnapshotScalarFieldEnum)[keyof typeof UserPortfolioSummarySnapshotScalarFieldEnum]


export const UserPortfolioExposureSnapshotScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  dimensionId: 'dimensionId',
  availability: 'availability',
  sourceAsOf: 'sourceAsOf',
  source: 'source',
  totalMarketValue: 'totalMarketValue',
  mappedMarketValue: 'mappedMarketValue',
  coveragePct: 'coveragePct',
  mappedSourceItemCount: 'mappedSourceItemCount',
  totalSourceItemCount: 'totalSourceItemCount',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioExposureSnapshotScalarFieldEnum = (typeof UserPortfolioExposureSnapshotScalarFieldEnum)[keyof typeof UserPortfolioExposureSnapshotScalarFieldEnum]


export const UserPortfolioExposureSnapshotItemScalarFieldEnum = {
  id: 'id',
  exposureSnapshotId: 'exposureSnapshotId',
  valueId: 'valueId',
  instrumentId: 'instrumentId',
  assetCode: 'assetCode',
  assetName: 'assetName',
  sourceItemKey: 'sourceItemKey',
  label: 'label',
  detail: 'detail',
  sourceWeightPct: 'sourceWeightPct',
  marketValue: 'marketValue',
  portfolioPct: 'portfolioPct',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioExposureSnapshotItemScalarFieldEnum = (typeof UserPortfolioExposureSnapshotItemScalarFieldEnum)[keyof typeof UserPortfolioExposureSnapshotItemScalarFieldEnum]


export const UserPortfolioExposureSnapshotValueScalarFieldEnum = {
  id: 'id',
  exposureSnapshotId: 'exposureSnapshotId',
  valueId: 'valueId',
  sourceItemCount: 'sourceItemCount',
  marketValue: 'marketValue',
  portfolioPct: 'portfolioPct',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioExposureSnapshotValueScalarFieldEnum = (typeof UserPortfolioExposureSnapshotValueScalarFieldEnum)[keyof typeof UserPortfolioExposureSnapshotValueScalarFieldEnum]


export const UserPortfolioPatrimonyHistoryScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  referenceMonth: 'referenceMonth',
  totalMarketValue: 'totalMarketValue',
  investedAmount: 'investedAmount',
  paidIncomeAmount: 'paidIncomeAmount',
  paidAmortizationAmount: 'paidAmortizationAmount',
  theoreticalCashBalance: 'theoreticalCashBalance',
  inferredExternalContributionAmount: 'inferredExternalContributionAmount',
  cumulativeInferredExternalContributionAmount: 'cumulativeInferredExternalContributionAmount',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioPatrimonyHistoryScalarFieldEnum = (typeof UserPortfolioPatrimonyHistoryScalarFieldEnum)[keyof typeof UserPortfolioPatrimonyHistoryScalarFieldEnum]


export const UserPortfolioPatrimonyTypeHistoryScalarFieldEnum = {
  id: 'id',
  patrimonyHistoryId: 'patrimonyHistoryId',
  instrumentTypeId: 'instrumentTypeId',
  marketValue: 'marketValue',
  portfolioPct: 'portfolioPct',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioPatrimonyTypeHistoryScalarFieldEnum = (typeof UserPortfolioPatrimonyTypeHistoryScalarFieldEnum)[keyof typeof UserPortfolioPatrimonyTypeHistoryScalarFieldEnum]


export const UserPortfolioPatrimonyCategoryHistoryScalarFieldEnum = {
  id: 'id',
  patrimonyHistoryId: 'patrimonyHistoryId',
  assetCategory: 'assetCategory',
  marketValue: 'marketValue',
  investedAmount: 'investedAmount',
  portfolioPct: 'portfolioPct',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioPatrimonyCategoryHistoryScalarFieldEnum = (typeof UserPortfolioPatrimonyCategoryHistoryScalarFieldEnum)[keyof typeof UserPortfolioPatrimonyCategoryHistoryScalarFieldEnum]


export const UserPortfolioPatrimonyAssetHistoryScalarFieldEnum = {
  id: 'id',
  patrimonyHistoryId: 'patrimonyHistoryId',
  instrumentId: 'instrumentId',
  assetCategory: 'assetCategory',
  assetCode: 'assetCode',
  assetName: 'assetName',
  marketValue: 'marketValue',
  investedAmount: 'investedAmount',
  portfolioPct: 'portfolioPct',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioPatrimonyAssetHistoryScalarFieldEnum = (typeof UserPortfolioPatrimonyAssetHistoryScalarFieldEnum)[keyof typeof UserPortfolioPatrimonyAssetHistoryScalarFieldEnum]


export const UserPortfolioInvestmentJournalScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  eventDate: 'eventDate',
  eventOrder: 'eventOrder',
  assetCategory: 'assetCategory',
  assetCode: 'assetCode',
  eventKind: 'eventKind',
  quantityOpen: 'quantityOpen',
  marketValue: 'marketValue',
  marketValueIpca: 'marketValueIpca',
  purchasesIpca: 'purchasesIpca',
  salesIpca: 'salesIpca',
  netInvestedIpca: 'netInvestedIpca',
  dividendsIpca: 'dividendsIpca',
  amortizationsIpca: 'amortizationsIpca',
  openPositionTargetIpca: 'openPositionTargetIpca',
  openPositionSurplusIpca: 'openPositionSurplusIpca',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioInvestmentJournalScalarFieldEnum = (typeof UserPortfolioInvestmentJournalScalarFieldEnum)[keyof typeof UserPortfolioInvestmentJournalScalarFieldEnum]


export const UserPortfolioInvestmentJournalMonthlyScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  referenceDate: 'referenceDate',
  scopeType: 'scopeType',
  scopeKey: 'scopeKey',
  marketValue: 'marketValue',
  marketValueIpca: 'marketValueIpca',
  purchasesIpca: 'purchasesIpca',
  salesIpca: 'salesIpca',
  netInvestedIpca: 'netInvestedIpca',
  dividendsIpca: 'dividendsIpca',
  amortizationsIpca: 'amortizationsIpca',
  openPositionTargetIpca: 'openPositionTargetIpca',
  openPositionSurplusIpca: 'openPositionSurplusIpca',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioInvestmentJournalMonthlyScalarFieldEnum = (typeof UserPortfolioInvestmentJournalMonthlyScalarFieldEnum)[keyof typeof UserPortfolioInvestmentJournalMonthlyScalarFieldEnum]


export const UserPortfolioCapitalPreservationSnapshotScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  referenceMonth: 'referenceMonth',
  requestedWindowMonths: 'requestedWindowMonths',
  actualWindowMonths: 'actualWindowMonths',
  includeAmortization: 'includeAmortization',
  status: 'status',
  unavailableReason: 'unavailableReason',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  asOf: 'asOf',
  ipcaThrough: 'ipcaThrough',
  startingPatrimony: 'startingPatrimony',
  targetPatrimonyIpca: 'targetPatrimonyIpca',
  endingPatrimony: 'endingPatrimony',
  paidIncomeAmount: 'paidIncomeAmount',
  paidAmortizationAmount: 'paidAmortizationAmount',
  incomeRequiredToPreserve: 'incomeRequiredToPreserve',
  incomeAvailableToWithdraw: 'incomeAvailableToWithdraw',
  withdrawableIncomeMonthlyAmount: 'withdrawableIncomeMonthlyAmount',
  withdrawableIncomePct: 'withdrawableIncomePct',
  ipcaAccumulatedPct: 'ipcaAccumulatedPct',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioCapitalPreservationSnapshotScalarFieldEnum = (typeof UserPortfolioCapitalPreservationSnapshotScalarFieldEnum)[keyof typeof UserPortfolioCapitalPreservationSnapshotScalarFieldEnum]


export const UserPortfolioPositionHistoryScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  instrumentId: 'instrumentId',
  assetCategory: 'assetCategory',
  assetCode: 'assetCode',
  assetName: 'assetName',
  positionDate: 'positionDate',
  quantity: 'quantity',
  averagePrice: 'averagePrice',
  averagePriceAdjusted: 'averagePriceAdjusted',
  investedAmount: 'investedAmount',
  realizedDividends: 'realizedDividends',
  realizedAmortization: 'realizedAmortization',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioPositionHistoryScalarFieldEnum = (typeof UserPortfolioPositionHistoryScalarFieldEnum)[keyof typeof UserPortfolioPositionHistoryScalarFieldEnum]


export const UserPortfolioIncomeHistoryScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  instrumentId: 'instrumentId',
  incomeType: 'incomeType',
  assetCategory: 'assetCategory',
  assetCode: 'assetCode',
  assetName: 'assetName',
  eventDate: 'eventDate',
  comDate: 'comDate',
  payDate: 'payDate',
  yearMonth: 'yearMonth',
  quantityBase: 'quantityBase',
  amountPerShareAdjusted: 'amountPerShareAdjusted',
  grossAmount: 'grossAmount',
  isForecast: 'isForecast',
  source: 'source',
  sourceEventId: 'sourceEventId',
  asOf: 'asOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioIncomeHistoryScalarFieldEnum = (typeof UserPortfolioIncomeHistoryScalarFieldEnum)[keyof typeof UserPortfolioIncomeHistoryScalarFieldEnum]


export const UserPortfolioProcessingDiagnosticScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  asOf: 'asOf',
  status: 'status',
  sourceLabel: 'sourceLabel',
  summary: 'summary',
  items: 'items',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioProcessingDiagnosticScalarFieldEnum = (typeof UserPortfolioProcessingDiagnosticScalarFieldEnum)[keyof typeof UserPortfolioProcessingDiagnosticScalarFieldEnum]


export const UserPortfolioImportSessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  portfolioId: 'portfolioId',
  portfolioType: 'portfolioType',
  source: 'source',
  status: 'status',
  fileName: 'fileName',
  fileChecksum: 'fileChecksum',
  proposedName: 'proposedName',
  proposedDescription: 'proposedDescription',
  attempts: 'attempts',
  maxAttempts: 'maxAttempts',
  errorCode: 'errorCode',
  errorMessage: 'errorMessage',
  errorDetails: 'errorDetails',
  errorStage: 'errorStage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  completedAt: 'completedAt'
} as const

export type UserPortfolioImportSessionScalarFieldEnum = (typeof UserPortfolioImportSessionScalarFieldEnum)[keyof typeof UserPortfolioImportSessionScalarFieldEnum]


export const UserPortfolioImportSessionItemScalarFieldEnum = {
  id: 'id',
  sessionId: 'sessionId',
  rowNumber: 'rowNumber',
  sheetName: 'sheetName',
  rawValues: 'rawValues',
  structuralValues: 'structuralValues',
  fingerprint: 'fingerprint',
  occurrenceNumber: 'occurrenceNumber',
  processingStatus: 'processingStatus',
  processingResult: 'processingResult',
  processedAt: 'processedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioImportSessionItemScalarFieldEnum = (typeof UserPortfolioImportSessionItemScalarFieldEnum)[keyof typeof UserPortfolioImportSessionItemScalarFieldEnum]


export const InstrumentTypeScalarFieldEnum = {
  id: 'id',
  symbol: 'symbol',
  typeFnet: 'typeFnet',
  typeCem: 'typeCem',
  description: 'description',
  descriptionType: 'descriptionType',
  isPortfolioSupported: 'isPortfolioSupported',
  origin: 'origin',
  instrumentClass: 'instrumentClass',
  createdAt: 'createdAt'
} as const

export type InstrumentTypeScalarFieldEnum = (typeof InstrumentTypeScalarFieldEnum)[keyof typeof InstrumentTypeScalarFieldEnum]


export const InstrumentScalarFieldEnum = {
  id: 'id',
  idFnet: 'idFnet',
  idCem: 'idCem',
  name: 'name',
  companyName: 'companyName',
  instrumentTypeId: 'instrumentTypeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type InstrumentScalarFieldEnum = (typeof InstrumentScalarFieldEnum)[keyof typeof InstrumentScalarFieldEnum]


export const TreasuryQuoteScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  quoteDate: 'quoteDate',
  maturityDate: 'maturityDate',
  conversionDate: 'conversionDate',
  titleType: 'titleType',
  buyRateMorning: 'buyRateMorning',
  sellRateMorning: 'sellRateMorning',
  buyPuMorning: 'buyPuMorning',
  sellPuMorning: 'sellPuMorning',
  basePuMorning: 'basePuMorning',
  source: 'source',
  sourceAsOf: 'sourceAsOf',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TreasuryQuoteScalarFieldEnum = (typeof TreasuryQuoteScalarFieldEnum)[keyof typeof TreasuryQuoteScalarFieldEnum]


export const FixedIncomeCashFlowScheduleScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  referenceDate: 'referenceDate',
  maturityDate: 'maturityDate',
  riskFactor: 'riskFactor',
  scheduleMethod: 'scheduleMethod',
  dayCountConvention: 'dayCountConvention',
  status: 'status',
  unavailableReason: 'unavailableReason',
  source: 'source',
  sourceAsOf: 'sourceAsOf',
  rulesVersion: 'rulesVersion',
  rulesFingerprint: 'rulesFingerprint',
  scheduleFingerprint: 'scheduleFingerprint',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FixedIncomeCashFlowScheduleScalarFieldEnum = (typeof FixedIncomeCashFlowScheduleScalarFieldEnum)[keyof typeof FixedIncomeCashFlowScheduleScalarFieldEnum]


export const FixedIncomeCashFlowScalarFieldEnum = {
  id: 'id',
  scheduleId: 'scheduleId',
  sequence: 'sequence',
  paymentDate: 'paymentDate',
  flowType: 'flowType',
  amount: 'amount',
  couponRate: 'couponRate',
  indexer: 'indexer',
  projected: 'projected',
  source: 'source',
  createdAt: 'createdAt'
} as const

export type FixedIncomeCashFlowScalarFieldEnum = (typeof FixedIncomeCashFlowScalarFieldEnum)[keyof typeof FixedIncomeCashFlowScalarFieldEnum]


export const TreasuryFeeRuleScalarFieldEnum = {
  id: 'id',
  titleType: 'titleType',
  annualFeeRate: 'annualFeeRate',
  chargeModel: 'chargeModel',
  exemptionAmount: 'exemptionAmount',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TreasuryFeeRuleScalarFieldEnum = (typeof TreasuryFeeRuleScalarFieldEnum)[keyof typeof TreasuryFeeRuleScalarFieldEnum]


export const UserPortfolioExpenseScalarFieldEnum = {
  id: 'id',
  portfolioId: 'portfolioId',
  instrumentId: 'instrumentId',
  assetCategory: 'assetCategory',
  assetCode: 'assetCode',
  assetName: 'assetName',
  expenseType: 'expenseType',
  occurredAt: 'occurredAt',
  grossAmount: 'grossAmount',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserPortfolioExpenseScalarFieldEnum = (typeof UserPortfolioExpenseScalarFieldEnum)[keyof typeof UserPortfolioExpenseScalarFieldEnum]


export const FixedIncomeScreenerSnapshotScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  quoteDate: 'quoteDate',
  maturityDate: 'maturityDate',
  conversionDate: 'conversionDate',
  titleType: 'titleType',
  remunerationType: 'remunerationType',
  indexer: 'indexer',
  cashFlowType: 'cashFlowType',
  paymentFrequency: 'paymentFrequency',
  riskFactor: 'riskFactor',
  taxRegime: 'taxRegime',
  liquidity: 'liquidity',
  buyRateMorning: 'buyRateMorning',
  sellRateMorning: 'sellRateMorning',
  buyPuMorning: 'buyPuMorning',
  sellPuMorning: 'sellPuMorning',
  basePuMorning: 'basePuMorning',
  daysToMaturity: 'daysToMaturity',
  durationYears: 'durationYears',
  modifiedDurationYears: 'modifiedDurationYears',
  dv01: 'dv01',
  convexity: 'convexity',
  sensitivityShockBps: 'sensitivityShockBps',
  sensitivityUp25BpsPct: 'sensitivityUp25BpsPct',
  sensitivityDown25BpsPct: 'sensitivityDown25BpsPct',
  sensitivityMethod: 'sensitivityMethod',
  riskMetricsStatus: 'riskMetricsStatus',
  riskMetricsUnavailableReason: 'riskMetricsUnavailableReason',
  cashFlowScheduleId: 'cashFlowScheduleId',
  rulesVersion: 'rulesVersion',
  rulesGeneration: 'rulesGeneration',
  rulesFingerprint: 'rulesFingerprint',
  source: 'source',
  sourceAsOf: 'sourceAsOf',
  calculatedAt: 'calculatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FixedIncomeScreenerSnapshotScalarFieldEnum = (typeof FixedIncomeScreenerSnapshotScalarFieldEnum)[keyof typeof FixedIncomeScreenerSnapshotScalarFieldEnum]


export const InstrumentTradingIdentityScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  referenceDate: 'referenceDate',
  tradingCode: 'tradingCode',
  shortName: 'shortName',
  paperSpecification: 'paperSpecification',
  isinCode: 'isinCode',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type InstrumentTradingIdentityScalarFieldEnum = (typeof InstrumentTradingIdentityScalarFieldEnum)[keyof typeof InstrumentTradingIdentityScalarFieldEnum]


export const InstrumentCnpjScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  cnpj: 'cnpj',
  updatedAt: 'updatedAt'
} as const

export type InstrumentCnpjScalarFieldEnum = (typeof InstrumentCnpjScalarFieldEnum)[keyof typeof InstrumentCnpjScalarFieldEnum]


export const CvmFundScalarFieldEnum = {
  idRegistroFundo: 'idRegistroFundo',
  cnpjFundo: 'cnpjFundo',
  codigoCvm: 'codigoCvm',
  dataRegistro: 'dataRegistro',
  dataConstituicao: 'dataConstituicao',
  tipoFundo: 'tipoFundo',
  denominacaoSocial: 'denominacaoSocial',
  dataCancelamento: 'dataCancelamento',
  situacao: 'situacao',
  dataInicioSituacao: 'dataInicioSituacao',
  dataAdaptacaoRcvm175: 'dataAdaptacaoRcvm175',
  dataInicioExercicioSocial: 'dataInicioExercicioSocial',
  dataFimExercicioSocial: 'dataFimExercicioSocial',
  patrimonioLiquido: 'patrimonioLiquido',
  dataPatrimonioLiquido: 'dataPatrimonioLiquido',
  diretor: 'diretor',
  cnpjAdministrador: 'cnpjAdministrador',
  administrador: 'administrador',
  tipoPessoaGestor: 'tipoPessoaGestor',
  cpfCnpjGestor: 'cpfCnpjGestor',
  gestor: 'gestor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFundScalarFieldEnum = (typeof CvmFundScalarFieldEnum)[keyof typeof CvmFundScalarFieldEnum]


export const CvmFundClassScalarFieldEnum = {
  idRegistroClasse: 'idRegistroClasse',
  idRegistroFundo: 'idRegistroFundo',
  cnpjClasse: 'cnpjClasse',
  codigoCvm: 'codigoCvm',
  dataRegistro: 'dataRegistro',
  dataConstituicao: 'dataConstituicao',
  dataInicio: 'dataInicio',
  tipoClasse: 'tipoClasse',
  denominacaoSocial: 'denominacaoSocial',
  situacao: 'situacao',
  dataInicioSituacao: 'dataInicioSituacao',
  classificacao: 'classificacao',
  indicadorDesempenho: 'indicadorDesempenho',
  classeCotas: 'classeCotas',
  classificacaoAnbima: 'classificacaoAnbima',
  tributacaoLongoPrazo: 'tributacaoLongoPrazo',
  entidadeInvestimento: 'entidadeInvestimento',
  permitidoAplicacaoCemPorCentoExterior: 'permitidoAplicacaoCemPorCentoExterior',
  classeEsg: 'classeEsg',
  formaCondominio: 'formaCondominio',
  exclusivo: 'exclusivo',
  publicoAlvo: 'publicoAlvo',
  patrimonioLiquido: 'patrimonioLiquido',
  dataPatrimonioLiquido: 'dataPatrimonioLiquido',
  cnpjAuditor: 'cnpjAuditor',
  auditor: 'auditor',
  cnpjCustodiante: 'cnpjCustodiante',
  custodiante: 'custodiante',
  cnpjControlador: 'cnpjControlador',
  controlador: 'controlador',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFundClassScalarFieldEnum = (typeof CvmFundClassScalarFieldEnum)[keyof typeof CvmFundClassScalarFieldEnum]


export const CvmFundSubclassScalarFieldEnum = {
  idRegistroClasse: 'idRegistroClasse',
  idSubclasse: 'idSubclasse',
  codigoCvm: 'codigoCvm',
  dataConstituicao: 'dataConstituicao',
  dataInicio: 'dataInicio',
  denominacaoSocial: 'denominacaoSocial',
  situacao: 'situacao',
  dataInicioSituacao: 'dataInicioSituacao',
  formaCondominio: 'formaCondominio',
  exclusivo: 'exclusivo',
  publicoAlvo: 'publicoAlvo',
  previdenciario: 'previdenciario',
  exclusivoInr: 'exclusivoInr',
  exclusivoPrevidenciaComplementar: 'exclusivoPrevidenciaComplementar',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFundSubclassScalarFieldEnum = (typeof CvmFundSubclassScalarFieldEnum)[keyof typeof CvmFundSubclassScalarFieldEnum]


export const CvmFiiInfMensalGeralScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  dataEntrega: 'dataEntrega',
  nomeFundoClasse: 'nomeFundoClasse',
  dataFuncionamento: 'dataFuncionamento',
  publicoAlvo: 'publicoAlvo',
  codigoIsin: 'codigoIsin',
  quantidadeCotasEmitidas: 'quantidadeCotasEmitidas',
  fundoExclusivo: 'fundoExclusivo',
  cotistasVinculoFamiliar: 'cotistasVinculoFamiliar',
  mandato: 'mandato',
  segmentoAtuacao: 'segmentoAtuacao',
  tipoGestao: 'tipoGestao',
  prazoDuracao: 'prazoDuracao',
  dataPrazoDuracao: 'dataPrazoDuracao',
  encerramentoExercicioSocial: 'encerramentoExercicioSocial',
  mercadoNegociacaoBolsa: 'mercadoNegociacaoBolsa',
  mercadoNegociacaoMbo: 'mercadoNegociacaoMbo',
  mercadoNegociacaoMb: 'mercadoNegociacaoMb',
  entidadeAdministradoraBvmf: 'entidadeAdministradoraBvmf',
  entidadeAdministradoraCetip: 'entidadeAdministradoraCetip',
  nomeAdministrador: 'nomeAdministrador',
  cnpjAdministrador: 'cnpjAdministrador',
  logradouro: 'logradouro',
  numero: 'numero',
  complemento: 'complemento',
  bairro: 'bairro',
  cidade: 'cidade',
  estado: 'estado',
  cep: 'cep',
  telefone1: 'telefone1',
  telefone2: 'telefone2',
  telefone3: 'telefone3',
  site: 'site',
  email: 'email',
  tipoFundoClasse: 'tipoFundoClasse',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfMensalGeralScalarFieldEnum = (typeof CvmFiiInfMensalGeralScalarFieldEnum)[keyof typeof CvmFiiInfMensalGeralScalarFieldEnum]


export const CvmFiiInfMensalAtivoPassivoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  totalNecessidadesLiquidez: 'totalNecessidadesLiquidez',
  disponibilidades: 'disponibilidades',
  titulosPublicos: 'titulosPublicos',
  titulosPrivados: 'titulosPrivados',
  fundosRendaFixa: 'fundosRendaFixa',
  totalInvestido: 'totalInvestido',
  direitosBensImoveis: 'direitosBensImoveis',
  terrenos: 'terrenos',
  imoveisRendaAcabados: 'imoveisRendaAcabados',
  imoveisRendaConstrucao: 'imoveisRendaConstrucao',
  imoveisVendaAcabados: 'imoveisVendaAcabados',
  imoveisVendaConstrucao: 'imoveisVendaConstrucao',
  outrosDireitosReais: 'outrosDireitosReais',
  acoes: 'acoes',
  debentures: 'debentures',
  bonusSubscricao: 'bonusSubscricao',
  certificadosDepositoValoresMobiliarios: 'certificadosDepositoValoresMobiliarios',
  cedulasDebentures: 'cedulasDebentures',
  fundoAcoes: 'fundoAcoes',
  fip: 'fip',
  fii: 'fii',
  fdic: 'fdic',
  outrasCotasFi: 'outrasCotasFi',
  notasPromissorias: 'notasPromissorias',
  acoesSociedadesAtividadesFii: 'acoesSociedadesAtividadesFii',
  cotasSociedadesAtividadesFii: 'cotasSociedadesAtividadesFii',
  cepac: 'cepac',
  cri: 'cri',
  criCra: 'criCra',
  letrasHipotecarias: 'letrasHipotecarias',
  lci: 'lci',
  lciLca: 'lciLca',
  lig: 'lig',
  outrosValoresMobliarios: 'outrosValoresMobliarios',
  valoresReceber: 'valoresReceber',
  contasReceberAluguel: 'contasReceberAluguel',
  contasReceberVendaImoveis: 'contasReceberVendaImoveis',
  outrosValoresReceber: 'outrosValoresReceber',
  rendimentosDistribuir: 'rendimentosDistribuir',
  taxaAdministracaoPagar: 'taxaAdministracaoPagar',
  taxaPerformancePagar: 'taxaPerformancePagar',
  obrigacoesAquisicaoImoveis: 'obrigacoesAquisicaoImoveis',
  adiantamentoVendaImoveis: 'adiantamentoVendaImoveis',
  adiantamentoAlugueis: 'adiantamentoAlugueis',
  obrigacoesSecuritizacaoRecebiveis: 'obrigacoesSecuritizacaoRecebiveis',
  instrumentosFinanceirosDerivativos: 'instrumentosFinanceirosDerivativos',
  provisoesContigencias: 'provisoesContigencias',
  outrosValoresPagar: 'outrosValoresPagar',
  totalPassivo: 'totalPassivo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfMensalAtivoPassivoScalarFieldEnum = (typeof CvmFiiInfMensalAtivoPassivoScalarFieldEnum)[keyof typeof CvmFiiInfMensalAtivoPassivoScalarFieldEnum]


export const CvmFiiInfMensalComplementoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  dataInformacaoNumeroCotistas: 'dataInformacaoNumeroCotistas',
  totalNumeroCotistas: 'totalNumeroCotistas',
  numeroCotistasPessoaFisica: 'numeroCotistasPessoaFisica',
  numeroCotistasPessoaJuridicaNaoFinanceira: 'numeroCotistasPessoaJuridicaNaoFinanceira',
  numeroCotistasBancoComercial: 'numeroCotistasBancoComercial',
  numeroCotistasCorretoraDistribuidora: 'numeroCotistasCorretoraDistribuidora',
  numeroCotistasOutrasPessoasJuridicasFinanceira: 'numeroCotistasOutrasPessoasJuridicasFinanceira',
  numeroCotistasInvestidoresNaoResidentes: 'numeroCotistasInvestidoresNaoResidentes',
  numeroCotistasEntidadeAbertaPrevidenciaComplementar: 'numeroCotistasEntidadeAbertaPrevidenciaComplementar',
  numeroCotistasEntidadeFechadaPrevidenciaComplementar: 'numeroCotistasEntidadeFechadaPrevidenciaComplementar',
  numeroCotistasRegimeProprioPrevidenciaServidoresPublicos: 'numeroCotistasRegimeProprioPrevidenciaServidoresPublicos',
  numeroCotistasSociedadeSeguradoraResseguradora: 'numeroCotistasSociedadeSeguradoraResseguradora',
  numeroCotistasSociedadeCapitalizacaoArrendamentoMercantil: 'numeroCotistasSociedadeCapitalizacaoArrendamentoMercantil',
  numeroCotistasFii: 'numeroCotistasFii',
  numeroCotistasOutrosFundos: 'numeroCotistasOutrosFundos',
  numeroCotistasDistribuidoresFundo: 'numeroCotistasDistribuidoresFundo',
  numeroCotistasOutrosTipos: 'numeroCotistasOutrosTipos',
  valorAtivo: 'valorAtivo',
  patrimonioLiquido: 'patrimonioLiquido',
  cotasEmitidas: 'cotasEmitidas',
  valorPatrimonialCotas: 'valorPatrimonialCotas',
  percentualDespesasTaxaAdministracao: 'percentualDespesasTaxaAdministracao',
  percentualDespesasAgenteCustodiante: 'percentualDespesasAgenteCustodiante',
  percentualRentabilidadeEfetivaMes: 'percentualRentabilidadeEfetivaMes',
  percentualRentabilidadePatrimonialMes: 'percentualRentabilidadePatrimonialMes',
  percentualDividendYieldMes: 'percentualDividendYieldMes',
  percentualAmortizacaoCotasMes: 'percentualAmortizacaoCotasMes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfMensalComplementoScalarFieldEnum = (typeof CvmFiiInfMensalComplementoScalarFieldEnum)[keyof typeof CvmFiiInfMensalComplementoScalarFieldEnum]


export const CvmFiiInfTrimestralAlienacaoImovelScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  nomeImovel: 'nomeImovel',
  endereco: 'endereco',
  dataAlienacao: 'dataAlienacao',
  area: 'area',
  numeroUnidades: 'numeroUnidades',
  outrasCaracteristicasRelevantes: 'outrasCaracteristicasRelevantes',
  percentualImovelTotalInvestido: 'percentualImovelTotalInvestido',
  percentualImovelPl: 'percentualImovelPl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralAlienacaoImovelScalarFieldEnum = (typeof CvmFiiInfTrimestralAlienacaoImovelScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralAlienacaoImovelScalarFieldEnum]


export const CvmFiiInfTrimestralAlienacaoTerrenoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  endereco: 'endereco',
  dataAlienacao: 'dataAlienacao',
  area: 'area',
  outrasCaracteristicasRelevantes: 'outrasCaracteristicasRelevantes',
  percentualTerrenoTotalInvestido: 'percentualTerrenoTotalInvestido',
  percentualTerrenoPl: 'percentualTerrenoPl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralAlienacaoTerrenoScalarFieldEnum = (typeof CvmFiiInfTrimestralAlienacaoTerrenoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralAlienacaoTerrenoScalarFieldEnum]


export const CvmFiiInfTrimestralAquisicaoImovelScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  nomeImovel: 'nomeImovel',
  endereco: 'endereco',
  area: 'area',
  numeroUnidades: 'numeroUnidades',
  outrasCaracteristicasRelevantes: 'outrasCaracteristicasRelevantes',
  percentualImovelTotalInvestido: 'percentualImovelTotalInvestido',
  categoria: 'categoria',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralAquisicaoImovelScalarFieldEnum = (typeof CvmFiiInfTrimestralAquisicaoImovelScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralAquisicaoImovelScalarFieldEnum]


export const CvmFiiInfTrimestralAquisicaoTerrenoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  endereco: 'endereco',
  area: 'area',
  outrasCaracteristicasRelevantes: 'outrasCaracteristicasRelevantes',
  percentualTerrenoTotalInvestido: 'percentualTerrenoTotalInvestido',
  percentualTerrenoPl: 'percentualTerrenoPl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralAquisicaoTerrenoScalarFieldEnum = (typeof CvmFiiInfTrimestralAquisicaoTerrenoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralAquisicaoTerrenoScalarFieldEnum]


export const CvmFiiInfTrimestralAtivoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  tipo: 'tipo',
  emissor: 'emissor',
  cnpjEmissor: 'cnpjEmissor',
  emissao: 'emissao',
  serie: 'serie',
  codigoAcao: 'codigoAcao',
  nomeAtivo: 'nomeAtivo',
  dataVencimento: 'dataVencimento',
  quantidade: 'quantidade',
  valor: 'valor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralAtivoScalarFieldEnum = (typeof CvmFiiInfTrimestralAtivoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralAtivoScalarFieldEnum]


export const CvmFiiInfTrimestralAtivoGarantiaRentabilidadeScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  nomeAtivo: 'nomeAtivo',
  percentualGarantidoRelativo: 'percentualGarantidoRelativo',
  garantidor: 'garantidor',
  principaisCaracteristicasGarantia: 'principaisCaracteristicasGarantia',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralAtivoGarantiaRentabilidadeScalarFieldEnum = (typeof CvmFiiInfTrimestralAtivoGarantiaRentabilidadeScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralAtivoGarantiaRentabilidadeScalarFieldEnum]


export const CvmFiiInfTrimestralComplementoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  percentualVencimentoValorTotalFaixaAte3Meses: 'percentualVencimentoValorTotalFaixaAte3Meses',
  percentualVencimentoReceitaFiiFaixaAte3Meses: 'percentualVencimentoReceitaFiiFaixaAte3Meses',
  percentualVencimentoValorTotalFaixa3a6Meses: 'percentualVencimentoValorTotalFaixa3a6Meses',
  percentualVencimentoReceitaFiiFaixa3a6Meses: 'percentualVencimentoReceitaFiiFaixa3a6Meses',
  percentualVencimentoValorTotalFaixa6a9Meses: 'percentualVencimentoValorTotalFaixa6a9Meses',
  percentualVencimentoReceitaFiiFaixa6a9Meses: 'percentualVencimentoReceitaFiiFaixa6a9Meses',
  percentualVencimentoValorTotalFaixa9a12Meses: 'percentualVencimentoValorTotalFaixa9a12Meses',
  percentualVencimentoReceitaFiiFaixa9a12Meses: 'percentualVencimentoReceitaFiiFaixa9a12Meses',
  percentualVencimentoValorTotalFaixa12a15Meses: 'percentualVencimentoValorTotalFaixa12a15Meses',
  percentualVencimentoReceitaFiiFaixa12a15Meses: 'percentualVencimentoReceitaFiiFaixa12a15Meses',
  percentualVencimentoValorTotalFaixa15a18Meses: 'percentualVencimentoValorTotalFaixa15a18Meses',
  percentualVencimentoReceitaFiiFaixa15a18Meses: 'percentualVencimentoReceitaFiiFaixa15a18Meses',
  percentualVencimentoValorTotalFaixa18a21Meses: 'percentualVencimentoValorTotalFaixa18a21Meses',
  percentualVencimentoReceitaFiiFaixa18a21Meses: 'percentualVencimentoReceitaFiiFaixa18a21Meses',
  percentualVencimentoValorTotalFaixa21a24Meses: 'percentualVencimentoValorTotalFaixa21a24Meses',
  percentualVencimentoReceitaFiiFaixa21a24Meses: 'percentualVencimentoReceitaFiiFaixa21a24Meses',
  percentualVencimentoValorTotalFaixa24a27Meses: 'percentualVencimentoValorTotalFaixa24a27Meses',
  percentualVencimentoReceitaFiiFaixa24a27Meses: 'percentualVencimentoReceitaFiiFaixa24a27Meses',
  percentualVencimentoValorTotalFaixa27a30Meses: 'percentualVencimentoValorTotalFaixa27a30Meses',
  percentualVencimentoReceitaFiiFaixa27a30Meses: 'percentualVencimentoReceitaFiiFaixa27a30Meses',
  percentualVencimentoValorTotalFaixa30a33Meses: 'percentualVencimentoValorTotalFaixa30a33Meses',
  percentualVencimentoReceitaFiiFaixa30a33Meses: 'percentualVencimentoReceitaFiiFaixa30a33Meses',
  percentualVencimentoValorTotalFaixa33a36Meses: 'percentualVencimentoValorTotalFaixa33a36Meses',
  percentualVencimentoReceitaFiiFaixa33a36Meses: 'percentualVencimentoReceitaFiiFaixa33a36Meses',
  percentualVencimentoValorTotalFaixaAcima36Meses: 'percentualVencimentoValorTotalFaixaAcima36Meses',
  percentualVencimentoReceitaFiiFaixaAcima36Meses: 'percentualVencimentoReceitaFiiFaixaAcima36Meses',
  percentualVencimentoValorTotalFaixaIndeterminado: 'percentualVencimentoValorTotalFaixaIndeterminado',
  percentualVencimentoReceitaFiiFaixaIndeterminado: 'percentualVencimentoReceitaFiiFaixaIndeterminado',
  percentualIndexadorValorTotalIgpm: 'percentualIndexadorValorTotalIgpm',
  percentualIndexadorReceitaFiiIgpm: 'percentualIndexadorReceitaFiiIgpm',
  percentualIndexadorValorTotalInpc: 'percentualIndexadorValorTotalInpc',
  percentualIndexadorReceitaFiiInpc: 'percentualIndexadorReceitaFiiInpc',
  percentualIndexadorValorTotalIpca: 'percentualIndexadorValorTotalIpca',
  percentualIndexadorReceitaFiiIpca: 'percentualIndexadorReceitaFiiIpca',
  percentualIndexadorValorTotalIncc: 'percentualIndexadorValorTotalIncc',
  percentualIndexadorReceitaFiiIncc: 'percentualIndexadorReceitaFiiIncc',
  caracteristicasContratuais: 'caracteristicasContratuais',
  politicaContratacaoSeguroImovelRendaAcabado: 'politicaContratacaoSeguroImovelRendaAcabado',
  politicaContratacaoSeguroImovelRendaConstrucao: 'politicaContratacaoSeguroImovelRendaConstrucao',
  politicaContratacaoSeguroImovelVendaAcabado: 'politicaContratacaoSeguroImovelVendaAcabado',
  politicaContratacaoSeguroImovelVendaConstrucao: 'politicaContratacaoSeguroImovelVendaConstrucao',
  ativoLiquidezValorDisponibilidades: 'ativoLiquidezValorDisponibilidades',
  ativoLiquidezValorTitulosPublicos: 'ativoLiquidezValorTitulosPublicos',
  ativoLiquidezValorTitulosPrivados: 'ativoLiquidezValorTitulosPrivados',
  ativoLiquidezValorFundosRendaFixa: 'ativoLiquidezValorFundosRendaFixa',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralComplementoScalarFieldEnum = (typeof CvmFiiInfTrimestralComplementoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralComplementoScalarFieldEnum]


export const CvmFiiInfTrimestralDireitoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  nomeAtivo: 'nomeAtivo',
  principaisCaracteristicas: 'principaisCaracteristicas',
  valor: 'valor',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralDireitoScalarFieldEnum = (typeof CvmFiiInfTrimestralDireitoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralDireitoScalarFieldEnum]


export const CvmFiiInfTrimestralGeralScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  tipoFundoClasse: 'tipoFundoClasse',
  dataEntrega: 'dataEntrega',
  nomeFundoClasse: 'nomeFundoClasse',
  dataFuncionamento: 'dataFuncionamento',
  publicoAlvo: 'publicoAlvo',
  codigoIsin: 'codigoIsin',
  quantidadeCotasEmitidas: 'quantidadeCotasEmitidas',
  fundoExclusivo: 'fundoExclusivo',
  fundoNaoListadoExclusivo: 'fundoNaoListadoExclusivo',
  cotistasVinculoFamiliar: 'cotistasVinculoFamiliar',
  mandato: 'mandato',
  segmentoAtuacao: 'segmentoAtuacao',
  tipoGestao: 'tipoGestao',
  prazoDuracao: 'prazoDuracao',
  dataPrazoDuracao: 'dataPrazoDuracao',
  encerramentoExercicioSocial: 'encerramentoExercicioSocial',
  mercadoNegociacaoBolsa: 'mercadoNegociacaoBolsa',
  mercadoNegociacaoMbo: 'mercadoNegociacaoMbo',
  mercadoNegociacaoMb: 'mercadoNegociacaoMb',
  entidadeAdministradoraBvmf: 'entidadeAdministradoraBvmf',
  entidadeAdministradoraCetip: 'entidadeAdministradoraCetip',
  nomeAdministrador: 'nomeAdministrador',
  cnpjAdministrador: 'cnpjAdministrador',
  logradouro: 'logradouro',
  numero: 'numero',
  complemento: 'complemento',
  bairro: 'bairro',
  cidade: 'cidade',
  estado: 'estado',
  cep: 'cep',
  telefone1: 'telefone1',
  telefone2: 'telefone2',
  telefone3: 'telefone3',
  site: 'site',
  email: 'email',
  dataEncerramentoTrimestre: 'dataEncerramentoTrimestre',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralGeralScalarFieldEnum = (typeof CvmFiiInfTrimestralGeralScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralGeralScalarFieldEnum]


export const CvmFiiInfTrimestralImovelScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  classe: 'classe',
  nomeImovel: 'nomeImovel',
  endereco: 'endereco',
  area: 'area',
  numeroUnidades: 'numeroUnidades',
  outrasCaracteristicasRelevantes: 'outrasCaracteristicasRelevantes',
  percentualVacancia: 'percentualVacancia',
  percentualInadimplencia: 'percentualInadimplencia',
  percentualReceitasFii: 'percentualReceitasFii',
  percentualLocado: 'percentualLocado',
  percentualVendido: 'percentualVendido',
  percentualConclusaoObrasRealizado: 'percentualConclusaoObrasRealizado',
  percentualConclusaoObrasPrevisto: 'percentualConclusaoObrasPrevisto',
  custoConstrucaoRealizado: 'custoConstrucaoRealizado',
  custoConstrucaoPrevisto: 'custoConstrucaoPrevisto',
  percentualImovelTotalInvestido: 'percentualImovelTotalInvestido',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralImovelScalarFieldEnum = (typeof CvmFiiInfTrimestralImovelScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralImovelScalarFieldEnum]


export const CvmFiiInfTrimestralImovelDesempenhoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  classe: 'classe',
  nomeEnderecoImovel: 'nomeEnderecoImovel',
  justificativaEvolucaoInferiorPrevisto: 'justificativaEvolucaoInferiorPrevisto',
  justificativaCustoSuperiorPrevisto: 'justificativaCustoSuperiorPrevisto',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralImovelDesempenhoScalarFieldEnum = (typeof CvmFiiInfTrimestralImovelDesempenhoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralImovelDesempenhoScalarFieldEnum]


export const CvmFiiInfTrimestralImovelRendaAcabadoContratoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  nomeEnderecoImovel: 'nomeEnderecoImovel',
  caracteristicasContratuais: 'caracteristicasContratuais',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralImovelRendaAcabadoContratoScalarFieldEnum = (typeof CvmFiiInfTrimestralImovelRendaAcabadoContratoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralImovelRendaAcabadoContratoScalarFieldEnum]


export const CvmFiiInfTrimestralImovelRendaAcabadoInquilinoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  nomeImovel: 'nomeImovel',
  setorAtuacao: 'setorAtuacao',
  percentualReceitaImovel: 'percentualReceitaImovel',
  percentualReceitasFii: 'percentualReceitasFii',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralImovelRendaAcabadoInquilinoScalarFieldEnum = (typeof CvmFiiInfTrimestralImovelRendaAcabadoInquilinoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralImovelRendaAcabadoInquilinoScalarFieldEnum]


export const CvmFiiInfTrimestralRentabilidadeEfetivaScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  mesReferencia: 'mesReferencia',
  percentualRentabilidadeEfetivaMes: 'percentualRentabilidadeEfetivaMes',
  percentualRentabilidadeAuferidaAusenciaGarantia: 'percentualRentabilidadeAuferidaAusenciaGarantia',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralRentabilidadeEfetivaScalarFieldEnum = (typeof CvmFiiInfTrimestralRentabilidadeEfetivaScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralRentabilidadeEfetivaScalarFieldEnum]


export const CvmFiiInfTrimestralResultadoContabilFinanceiroScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  receitaVendaEstoqueContabil: 'receitaVendaEstoqueContabil',
  receitaVendaEstoqueFinanceiro: 'receitaVendaEstoqueFinanceiro',
  custoEstoqueContabil: 'custoEstoqueContabil',
  custoEstoqueFinanceiro: 'custoEstoqueFinanceiro',
  ajusteRealizacaoEstoqueContabil: 'ajusteRealizacaoEstoqueContabil',
  ajusteRealizacaoEstoqueFinanceiro: 'ajusteRealizacaoEstoqueFinanceiro',
  outrasReceitasDespesasEstoqueContabil: 'outrasReceitasDespesasEstoqueContabil',
  outrasReceitasDespesasEstoqueFinanceiro: 'outrasReceitasDespesasEstoqueFinanceiro',
  resultadoLiquidoEstoqueContabil: 'resultadoLiquidoEstoqueContabil',
  resultadoLiquidoEstoqueFinanceiro: 'resultadoLiquidoEstoqueFinanceiro',
  receitaAluguelInvestimentoContabil: 'receitaAluguelInvestimentoContabil',
  receitaAluguelInvestimentoFinanceiro: 'receitaAluguelInvestimentoFinanceiro',
  despesaManutencaoInvestimentoContabil: 'despesaManutencaoInvestimentoContabil',
  despesaManutencaoInvestimentoFinanceiro: 'despesaManutencaoInvestimentoFinanceiro',
  receitaVendaInvestimentoContabil: 'receitaVendaInvestimentoContabil',
  receitaVendaInvestimentoFinanceiro: 'receitaVendaInvestimentoFinanceiro',
  custoInvestimentoContabil: 'custoInvestimentoContabil',
  custoInvestimentoFinanceiro: 'custoInvestimentoFinanceiro',
  ajusteJustoInvestimentoContabil: 'ajusteJustoInvestimentoContabil',
  ajusteJustoInvestimentoFinanceiro: 'ajusteJustoInvestimentoFinanceiro',
  outrasReceitasDespesasInvestimentoContabil: 'outrasReceitasDespesasInvestimentoContabil',
  outrasReceitasDespesasInvestimentoFinanceiro: 'outrasReceitasDespesasInvestimentoFinanceiro',
  resultadoLiquidoRendaContabil: 'resultadoLiquidoRendaContabil',
  resultadoLiquidoRendaInvestimentoFinanceiro: 'resultadoLiquidoRendaInvestimentoFinanceiro',
  receitaJurosTvmContabil: 'receitaJurosTvmContabil',
  receitaJurosTvmFinanceiro: 'receitaJurosTvmFinanceiro',
  ajusteJustoTvmContabil: 'ajusteJustoTvmContabil',
  ajusteJustoTvmFinanceiro: 'ajusteJustoTvmFinanceiro',
  resultadoVendaTvmContabil: 'resultadoVendaTvmContabil',
  resultadoVendaTvmFinanceiro: 'resultadoVendaTvmFinanceiro',
  outrasReceitasDespesasTvmContabil: 'outrasReceitasDespesasTvmContabil',
  outrasReceitasDespesasTvmFinanceiro: 'outrasReceitasDespesasTvmFinanceiro',
  resultadoLiquidoTvmContabil: 'resultadoLiquidoTvmContabil',
  resultadoLiquidoTvmFinanceiro: 'resultadoLiquidoTvmFinanceiro',
  resultadoLiquidoTotalContabil: 'resultadoLiquidoTotalContabil',
  resultadoLiquidoTotalFinanceiro: 'resultadoLiquidoTotalFinanceiro',
  receitaJurosAplicacaoContabil: 'receitaJurosAplicacaoContabil',
  receitaJurosAplicacaoFinanceiro: 'receitaJurosAplicacaoFinanceiro',
  ajusteJustoAplicacaoContabil: 'ajusteJustoAplicacaoContabil',
  ajusteJustoAplicacaoFinanceiro: 'ajusteJustoAplicacaoFinanceiro',
  resultadoVendaAplicacaoContabil: 'resultadoVendaAplicacaoContabil',
  resultadoVendaAplicacaoFinanceiro: 'resultadoVendaAplicacaoFinanceiro',
  outrasReceitasDespesasAplicacaoContabil: 'outrasReceitasDespesasAplicacaoContabil',
  outrasReceitasDespesasAplicacaoFinanceiro: 'outrasReceitasDespesasAplicacaoFinanceiro',
  resultadoLiquidoRecursoLiquidezContabil: 'resultadoLiquidoRecursoLiquidezContabil',
  resultadoLiquidoRecursoLiquidezFinanceiro: 'resultadoLiquidoRecursoLiquidezFinanceiro',
  resultadoLiquidoDerivativosContabil: 'resultadoLiquidoDerivativosContabil',
  resultadoLiquidoDerivativosFinanceiro: 'resultadoLiquidoDerivativosFinanceiro',
  taxaAdministracaoContabil: 'taxaAdministracaoContabil',
  taxaAdministracaoFinanceiro: 'taxaAdministracaoFinanceiro',
  taxaDesempenhoContabil: 'taxaDesempenhoContabil',
  taxaDesempenhoFinanceiro: 'taxaDesempenhoFinanceiro',
  despesaConsultoriaEspecializadaContabil: 'despesaConsultoriaEspecializadaContabil',
  despesaConsultoriaEspecializadaFinanceiro: 'despesaConsultoriaEspecializadaFinanceiro',
  despesaEmpresaEspecializadaContabil: 'despesaEmpresaEspecializadaContabil',
  despesaEmpresaEspecializadaFinanceiro: 'despesaEmpresaEspecializadaFinanceiro',
  despesaFormadorMercadoContabil: 'despesaFormadorMercadoContabil',
  despesaFormadorMercadoFinanceiro: 'despesaFormadorMercadoFinanceiro',
  despesaCustodiaContabil: 'despesaCustodiaContabil',
  despesaCustodiaFinanceiro: 'despesaCustodiaFinanceiro',
  despesaAuditoriaIndependenteContabil: 'despesaAuditoriaIndependenteContabil',
  despesaAuditoriaIndependenteFinanceiro: 'despesaAuditoriaIndependenteFinanceiro',
  despesaRepresentantesCotistasContabil: 'despesaRepresentantesCotistasContabil',
  despesaRepresentantesCotistasFinanceiro: 'despesaRepresentantesCotistasFinanceiro',
  taxaImpostoContribuicaoContabil: 'taxaImpostoContribuicaoContabil',
  taxaImpostoContribuicaoFinanceiro: 'taxaImpostoContribuicaoFinanceiro',
  despesaComissoesEmolumentosContabil: 'despesaComissoesEmolumentosContabil',
  despesaComissoesEmolumentosFinanceiro: 'despesaComissoesEmolumentosFinanceiro',
  despesaHonorariosDefesasContabil: 'despesaHonorariosDefesasContabil',
  despesaHonorariosDefesasFinanceiro: 'despesaHonorariosDefesasFinanceiro',
  despesaContratosSegurosContabil: 'despesaContratosSegurosContabil',
  despesaContratosSegurosFinanceiro: 'despesaContratosSegurosFinanceiro',
  despesaAvaliacoesContabil: 'despesaAvaliacoesContabil',
  despesaAvaliacoesFinanceiro: 'despesaAvaliacoesFinanceiro',
  taxaIngressoSaidaCotistaContabil: 'taxaIngressoSaidaCotistaContabil',
  taxaIngressoSaidaCotistaFinanceiro: 'taxaIngressoSaidaCotistaFinanceiro',
  despesaRegistroCartorioContabil: 'despesaRegistroCartorioContabil',
  despesaRegistroCartorioFinanceiro: 'despesaRegistroCartorioFinanceiro',
  outrasReceitasDepesasContabil: 'outrasReceitasDepesasContabil',
  outrasReceitasDepesasFinanceiro: 'outrasReceitasDepesasFinanceiro',
  totalReceitasDespesasContabil: 'totalReceitasDespesasContabil',
  totalReceitasDespesasFinanceiro: 'totalReceitasDespesasFinanceiro',
  resultadoTrimestralLiquidoContabil: 'resultadoTrimestralLiquidoContabil',
  resultadoTrimestralLiquidoFinanceiro: 'resultadoTrimestralLiquidoFinanceiro',
  resultadoFinanceiroLiquidoAcumulado: 'resultadoFinanceiroLiquidoAcumulado',
  resultadoFinanceiroLiquidoAcumulado95: 'resultadoFinanceiroLiquidoAcumulado95',
  parcelaRendimentoRetido: 'parcelaRendimentoRetido',
  lucroContabil: 'lucroContabil',
  rendimentosDeclarados: 'rendimentosDeclarados',
  rendimentosPagosAntecipadamente: 'rendimentosPagosAntecipadamente',
  rendimentoLiquidoPagar: 'rendimentoLiquidoPagar',
  percentualResultadoFinanceiroLiquidoDeclarado: 'percentualResultadoFinanceiroLiquidoDeclarado',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralResultadoContabilFinanceiroScalarFieldEnum = (typeof CvmFiiInfTrimestralResultadoContabilFinanceiroScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralResultadoContabilFinanceiroScalarFieldEnum]


export const CvmFiiInfTrimestralTerrenoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  endereco: 'endereco',
  outrasCaracteristicasRelevantes: 'outrasCaracteristicasRelevantes',
  area: 'area',
  percentualTerrenoTotalInvestido: 'percentualTerrenoTotalInvestido',
  percentualTerrenoPl: 'percentualTerrenoPl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfTrimestralTerrenoScalarFieldEnum = (typeof CvmFiiInfTrimestralTerrenoScalarFieldEnum)[keyof typeof CvmFiiInfTrimestralTerrenoScalarFieldEnum]


export const CvmFiiInfAnualAtivoAdquiridoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  nomeAtivo: 'nomeAtivo',
  origemRecursos: 'origemRecursos',
  objetivos: 'objetivos',
  montanteInvestido: 'montanteInvestido',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualAtivoAdquiridoScalarFieldEnum = (typeof CvmFiiInfAnualAtivoAdquiridoScalarFieldEnum)[keyof typeof CvmFiiInfAnualAtivoAdquiridoScalarFieldEnum]


export const CvmFiiInfAnualAtivoTransacaoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  dataTransacao: 'dataTransacao',
  dataAssembleia: 'dataAssembleia',
  naturezaTransacao: 'naturezaTransacao',
  ativoNegociado: 'ativoNegociado',
  contraparte: 'contraparte',
  valorEnvolvido: 'valorEnvolvido',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualAtivoTransacaoScalarFieldEnum = (typeof CvmFiiInfAnualAtivoTransacaoScalarFieldEnum)[keyof typeof CvmFiiInfAnualAtivoTransacaoScalarFieldEnum]


export const CvmFiiInfAnualAtivoValorContabilScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  valorJusto: 'valorJusto',
  nomeAtivo: 'nomeAtivo',
  valor: 'valor',
  percentualValorizacaoDesvalorizacao: 'percentualValorizacaoDesvalorizacao',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualAtivoValorContabilScalarFieldEnum = (typeof CvmFiiInfAnualAtivoValorContabilScalarFieldEnum)[keyof typeof CvmFiiInfAnualAtivoValorContabilScalarFieldEnum]


export const CvmFiiInfAnualComplementoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  analiseImpactoPerdaProcessosSigilosos: 'analiseImpactoPerdaProcessosSigilosos',
  cnpjCustodiante: 'cnpjCustodiante',
  cnpjEmpresaLocacao: 'cnpjEmpresaLocacao',
  conjunturaEconomicaPeriodoFindo: 'conjunturaEconomicaPeriodoFindo',
  criteriosAvaliacao: 'criteriosAvaliacao',
  enderecoEmpresaLocacao: 'enderecoEmpresaLocacao',
  nomeEmpresaLocacao: 'nomeEmpresaLocacao',
  perspectivaPeriodoSeguinte: 'perspectivaPeriodoSeguinte',
  praticaAssembleiaMeioEletronico: 'praticaAssembleiaMeioEletronico',
  programaInvestimentosExercicioSeguinte: 'programaInvestimentosExercicioSeguinte',
  resultadoExercicioFindo: 'resultadoExercicioFindo',
  telefoneEmpresaLocacao: 'telefoneEmpresaLocacao',
  cnpjConsultorEspecializado: 'cnpjConsultorEspecializado',
  politicaDivulgacaoFatoRelevante: 'politicaDivulgacaoFatoRelevante',
  nomeCustodiante: 'nomeCustodiante',
  telefoneFormadorMercado: 'telefoneFormadorMercado',
  telefoneGestor: 'telefoneGestor',
  enderecoFormadorMercado: 'enderecoFormadorMercado',
  nomeFormadorMercado: 'nomeFormadorMercado',
  percentualPatrimonioContabil: 'percentualPatrimonioContabil',
  telefoneDistribuidorCotas: 'telefoneDistribuidorCotas',
  enderecoAuditorIndependente: 'enderecoAuditorIndependente',
  politicaNegociacaoCotas: 'politicaNegociacaoCotas',
  meioComunicacaoCotistas: 'meioComunicacaoCotistas',
  cnpjAuditorIndependente: 'cnpjAuditorIndependente',
  responsaveisPoliticaDivulgacao: 'responsaveisPoliticaDivulgacao',
  nomeConsultorEspecializado: 'nomeConsultorEspecializado',
  politicaRemuneracao: 'politicaRemuneracao',
  enderecoDistribuidorCotas: 'enderecoDistribuidorCotas',
  nomeDistribuidorCotas: 'nomeDistribuidorCotas',
  enderecoGestor: 'enderecoGestor',
  telefoneConsultorEspecializado: 'telefoneConsultorEspecializado',
  enderecoCustodiante: 'enderecoCustodiante',
  cnpjFormadorMercado: 'cnpjFormadorMercado',
  enderecoEletronicoDocumentosAssembleiaGeral: 'enderecoEletronicoDocumentosAssembleiaGeral',
  cnpjGestor: 'cnpjGestor',
  regrasPrazosChamadaCapital: 'regrasPrazosChamadaCapital',
  enderecoConsultorEspecializado: 'enderecoConsultorEspecializado',
  enderecoFisicoDocumentosAssembleiaGeral: 'enderecoFisicoDocumentosAssembleiaGeral',
  telefoneAuditorIndependente: 'telefoneAuditorIndependente',
  valorPagoAnoReferencia: 'valorPagoAnoReferencia',
  regrasParticipacaoCotistasAssembleiaGeral: 'regrasParticipacaoCotistasAssembleiaGeral',
  politicaExercicioDireitoVoto: 'politicaExercicioDireitoVoto',
  nomeGestor: 'nomeGestor',
  percentualPatrimonioValorMercado: 'percentualPatrimonioValorMercado',
  linkDownloadAnexo: 'linkDownloadAnexo',
  cnpjDistribuidorCotas: 'cnpjDistribuidorCotas',
  nomeAuditorIndependente: 'nomeAuditorIndependente',
  telefoneCustodiante: 'telefoneCustodiante',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualComplementoScalarFieldEnum = (typeof CvmFiiInfAnualComplementoScalarFieldEnum)[keyof typeof CvmFiiInfAnualComplementoScalarFieldEnum]


export const CvmFiiInfAnualDiretorResponsavelScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  condenacaoProcessoCvm: 'condenacaoProcessoCvm',
  cpf: 'cpf',
  email: 'email',
  idade: 'idade',
  profissao: 'profissao',
  quantidadeCotasFiiCompradas: 'quantidadeCotasFiiCompradas',
  quantidadeCotasFiiVendidas: 'quantidadeCotasFiiVendidas',
  condenacaoCriminal: 'condenacaoCriminal',
  dataInicio: 'dataInicio',
  nomeDiretorResponsavel: 'nomeDiretorResponsavel',
  formacaoAcademica: 'formacaoAcademica',
  quantidadeCotasFiiDetidas: 'quantidadeCotasFiiDetidas',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualDiretorResponsavelScalarFieldEnum = (typeof CvmFiiInfAnualDiretorResponsavelScalarFieldEnum)[keyof typeof CvmFiiInfAnualDiretorResponsavelScalarFieldEnum]


export const CvmFiiInfAnualDistribuicaoCotistasScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  numeroCotasDetidasFaixa10a15: 'numeroCotasDetidasFaixa10a15',
  numeroCotasDetidasFaixa15a20: 'numeroCotasDetidasFaixa15a20',
  numeroCotasDetidasFaixa20a30: 'numeroCotasDetidasFaixa20a30',
  numeroCotasDetidasFaixa30a40: 'numeroCotasDetidasFaixa30a40',
  numeroCotasDetidasFaixa40a50: 'numeroCotasDetidasFaixa40a50',
  numeroCotasDetidasFaixa5a10: 'numeroCotasDetidasFaixa5a10',
  numeroCotasDetidasFaixaAcima50: 'numeroCotasDetidasFaixaAcima50',
  numeroCotasDetidasFaixaAte5: 'numeroCotasDetidasFaixaAte5',
  numeroCotistasFaixa10a15: 'numeroCotistasFaixa10a15',
  numeroCotistasFaixa15a20: 'numeroCotistasFaixa15a20',
  numeroCotistasFaixa20a30: 'numeroCotistasFaixa20a30',
  numeroCotistasFaixa30a40: 'numeroCotistasFaixa30a40',
  numeroCotistasFaixa40a50: 'numeroCotistasFaixa40a50',
  numeroCotistasFaixa5a10: 'numeroCotistasFaixa5a10',
  numeroCotistasFaixaAcima50: 'numeroCotistasFaixaAcima50',
  numeroCotistasFaixaAte5: 'numeroCotistasFaixaAte5',
  percentualCotasDetidasFaixa10a15: 'percentualCotasDetidasFaixa10a15',
  percentualCotasDetidasFaixa15a20: 'percentualCotasDetidasFaixa15a20',
  percentualCotasDetidasFaixa20a30: 'percentualCotasDetidasFaixa20a30',
  percentualCotasDetidasFaixa30a40: 'percentualCotasDetidasFaixa30a40',
  percentualCotasDetidasFaixa40a50: 'percentualCotasDetidasFaixa40a50',
  percentualCotasDetidasFaixa5a10: 'percentualCotasDetidasFaixa5a10',
  percentualCotasDetidasFaixaAcima50: 'percentualCotasDetidasFaixaAcima50',
  percentualCotasDetidasFaixaAte5: 'percentualCotasDetidasFaixaAte5',
  percentualDetidoPfFaixa10a15: 'percentualDetidoPfFaixa10a15',
  percentualDetidoPfFaixa15a20: 'percentualDetidoPfFaixa15a20',
  percentualDetidoPfFaixa20a30: 'percentualDetidoPfFaixa20a30',
  percentualDetidoPfFaixa30a40: 'percentualDetidoPfFaixa30a40',
  percentualDetidoPfFaixa40a50: 'percentualDetidoPfFaixa40a50',
  percentualDetidoPfFaixa5a10: 'percentualDetidoPfFaixa5a10',
  percentualDetidoPfFaixaAcima50: 'percentualDetidoPfFaixaAcima50',
  percentualDetidoPfFaixaAte5: 'percentualDetidoPfFaixaAte5',
  percentualDetidoPjFaixa10a15: 'percentualDetidoPjFaixa10a15',
  percentualDetidoPjFaixa15a20: 'percentualDetidoPjFaixa15a20',
  percentualDetidoPjFaixa20a30: 'percentualDetidoPjFaixa20a30',
  percentualDetidoPjFaixa30a40: 'percentualDetidoPjFaixa30a40',
  percentualDetidoPjFaixa40a50: 'percentualDetidoPjFaixa40a50',
  percentualDetidoPjFaixa5a10: 'percentualDetidoPjFaixa5a10',
  percentualDetidoPjFaixaAcima50: 'percentualDetidoPjFaixaAcima50',
  percentualDetidoPjFaixaAte5: 'percentualDetidoPjFaixaAte5',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualDistribuicaoCotistasScalarFieldEnum = (typeof CvmFiiInfAnualDistribuicaoCotistasScalarFieldEnum)[keyof typeof CvmFiiInfAnualDistribuicaoCotistasScalarFieldEnum]


export const CvmFiiInfAnualExperienciaProfissionalScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  cargoFuncao: 'cargoFuncao',
  funcao: 'funcao',
  nomeEmpresa: 'nomeEmpresa',
  periodo: 'periodo',
  atividadePrincipal: 'atividadePrincipal',
  nomeDiretorRepresentante: 'nomeDiretorRepresentante',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualExperienciaProfissionalScalarFieldEnum = (typeof CvmFiiInfAnualExperienciaProfissionalScalarFieldEnum)[keyof typeof CvmFiiInfAnualExperienciaProfissionalScalarFieldEnum]


export const CvmFiiInfAnualGeralScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  bairro: 'bairro',
  cep: 'cep',
  cidade: 'cidade',
  complemento: 'complemento',
  cotistasVinculoFamiliar: 'cotistasVinculoFamiliar',
  dataEntrega: 'dataEntrega',
  email: 'email',
  entidadeAdministradoraBvmf: 'entidadeAdministradoraBvmf',
  entidadeAdministradoraCetip: 'entidadeAdministradoraCetip',
  estado: 'estado',
  fundoExclusivo: 'fundoExclusivo',
  logradouro: 'logradouro',
  mercadoNegociacaoBolsa: 'mercadoNegociacaoBolsa',
  mercadoNegociacaoMb: 'mercadoNegociacaoMb',
  mercadoNegociacaoMbo: 'mercadoNegociacaoMbo',
  nomeAdministrador: 'nomeAdministrador',
  publicoAlvo: 'publicoAlvo',
  quantidadeCotasEmitidas: 'quantidadeCotasEmitidas',
  mandato: 'mandato',
  dataFuncionamento: 'dataFuncionamento',
  encerramentoExercicioSocial: 'encerramentoExercicioSocial',
  tipoGestao: 'tipoGestao',
  site: 'site',
  dataPrazoDuracao: 'dataPrazoDuracao',
  telefone1: 'telefone1',
  tipoFundoClasse: 'tipoFundoClasse',
  prazoDuracao: 'prazoDuracao',
  codigoIsin: 'codigoIsin',
  cnpjAdministrador: 'cnpjAdministrador',
  telefone2: 'telefone2',
  nomeFundoClasse: 'nomeFundoClasse',
  segmentoAtuacao: 'segmentoAtuacao',
  numero: 'numero',
  telefone3: 'telefone3',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualGeralScalarFieldEnum = (typeof CvmFiiInfAnualGeralScalarFieldEnum)[keyof typeof CvmFiiInfAnualGeralScalarFieldEnum]


export const CvmFiiInfAnualPrestadorServicoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  telefone: 'telefone',
  nomePrestador: 'nomePrestador',
  cnpjPrestador: 'cnpjPrestador',
  endereco: 'endereco',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualPrestadorServicoScalarFieldEnum = (typeof CvmFiiInfAnualPrestadorServicoScalarFieldEnum)[keyof typeof CvmFiiInfAnualPrestadorServicoScalarFieldEnum]


export const CvmFiiInfAnualProcessoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  numeroProcesso: 'numeroProcesso',
  principaisFatos: 'principaisFatos',
  instancia: 'instancia',
  juizo: 'juizo',
  valorCausa: 'valorCausa',
  dataInstauracao: 'dataInstauracao',
  chancePerda: 'chancePerda',
  partesProcesso: 'partesProcesso',
  analiseImpactoPerda: 'analiseImpactoPerda',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualProcessoScalarFieldEnum = (typeof CvmFiiInfAnualProcessoScalarFieldEnum)[keyof typeof CvmFiiInfAnualProcessoScalarFieldEnum]


export const CvmFiiInfAnualProcessoSemelhanteScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  numeroProcesso: 'numeroProcesso',
  causaContingencia: 'causaContingencia',
  valores: 'valores',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualProcessoSemelhanteScalarFieldEnum = (typeof CvmFiiInfAnualProcessoSemelhanteScalarFieldEnum)[keyof typeof CvmFiiInfAnualProcessoSemelhanteScalarFieldEnum]


export const CvmFiiInfAnualRepresentanteCotistaScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  rowHash: 'rowHash',
  condenacaoProcessoCvm: 'condenacaoProcessoCvm',
  cpf: 'cpf',
  dataEleicao: 'dataEleicao',
  email: 'email',
  idade: 'idade',
  profissao: 'profissao',
  quantidadeCotasFiiCompradas: 'quantidadeCotasFiiCompradas',
  terminoMandato: 'terminoMandato',
  percentualPatrimonioContabil: 'percentualPatrimonioContabil',
  quantidadeCotasFiiVendidas: 'quantidadeCotasFiiVendidas',
  condenacaoCriminal: 'condenacaoCriminal',
  formaRemuneracao: 'formaRemuneracao',
  nomeRepresentante: 'nomeRepresentante',
  formacaoAcademica: 'formacaoAcademica',
  valorPagoAnoReferencia: 'valorPagoAnoReferencia',
  quantidadeCotasFiiDetidas: 'quantidadeCotasFiiDetidas',
  percentualPatrimonioValorMercado: 'percentualPatrimonioValorMercado',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualRepresentanteCotistaScalarFieldEnum = (typeof CvmFiiInfAnualRepresentanteCotistaScalarFieldEnum)[keyof typeof CvmFiiInfAnualRepresentanteCotistaScalarFieldEnum]


export const CvmFiiInfAnualRepresentanteCotistaFundoScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  dataEleicao: 'dataEleicao',
  terminoMandato: 'terminoMandato',
  nomeFundo: 'nomeFundo',
  nomeRepresentante: 'nomeRepresentante',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiInfAnualRepresentanteCotistaFundoScalarFieldEnum = (typeof CvmFiiInfAnualRepresentanteCotistaFundoScalarFieldEnum)[keyof typeof CvmFiiInfAnualRepresentanteCotistaFundoScalarFieldEnum]


export const CvmFiiDfinScalarFieldEnum = {
  cnpjFundoClasse: 'cnpjFundoClasse',
  dataReferencia: 'dataReferencia',
  versao: 'versao',
  dataEntrega: 'dataEntrega',
  linkDownload: 'linkDownload',
  tipoFundoClasse: 'tipoFundoClasse',
  parecerAuditor: 'parecerAuditor',
  nomeFundoClasse: 'nomeFundoClasse',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiiDfinScalarFieldEnum = (typeof CvmFiiDfinScalarFieldEnum)[keyof typeof CvmFiiDfinScalarFieldEnum]


export const CvmFidcInfMensalTabIiiScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabIiiVlPassivo: 'tabIiiVlPassivo',
  tabIiiAVlPagar: 'tabIiiAVlPagar',
  tabIiiA1VlCprazo: 'tabIiiA1VlCprazo',
  tabIiiA2VlLprazo: 'tabIiiA2VlLprazo',
  tabIiiBVlPosicaoDeriv: 'tabIiiBVlPosicaoDeriv',
  tabIiiB1VlTermo: 'tabIiiB1VlTermo',
  tabIiiB2VlOpcao: 'tabIiiB2VlOpcao',
  tabIiiB3VlFuturo: 'tabIiiB3VlFuturo',
  tabIiiB4VlSwapPagar: 'tabIiiB4VlSwapPagar',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabIiiScalarFieldEnum = (typeof CvmFidcInfMensalTabIiiScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabIiiScalarFieldEnum]


export const CvmFidcInfMensalTabIiScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabIiVlCarteira: 'tabIiVlCarteira',
  tabIiAVlIndust: 'tabIiAVlIndust',
  tabIiBVlImobil: 'tabIiBVlImobil',
  tabIiCVlComerc: 'tabIiCVlComerc',
  tabIiC1VlComerc: 'tabIiC1VlComerc',
  tabIiC2VlVarejo: 'tabIiC2VlVarejo',
  tabIiC3VlArrend: 'tabIiC3VlArrend',
  tabIiDVlServ: 'tabIiDVlServ',
  tabIiD1VlServ: 'tabIiD1VlServ',
  tabIiD2VlServPublico: 'tabIiD2VlServPublico',
  tabIiD3VlServEduc: 'tabIiD3VlServEduc',
  tabIiD4VlEntret: 'tabIiD4VlEntret',
  tabIiEVlAgroneg: 'tabIiEVlAgroneg',
  tabIiFVlFinanc: 'tabIiFVlFinanc',
  tabIiF1VlCredPessoa: 'tabIiF1VlCredPessoa',
  tabIiF2VlCredPessoaConsig: 'tabIiF2VlCredPessoaConsig',
  tabIiF3VlCredCorp: 'tabIiF3VlCredCorp',
  tabIiF4VlMidmarket: 'tabIiF4VlMidmarket',
  tabIiF5VlVeiculo: 'tabIiF5VlVeiculo',
  tabIiF6VlImobilEmpresa: 'tabIiF6VlImobilEmpresa',
  tabIiF7VlImobilResid: 'tabIiF7VlImobilResid',
  tabIiF8VlOutro: 'tabIiF8VlOutro',
  tabIiGVlCredito: 'tabIiGVlCredito',
  tabIiHVlFactor: 'tabIiHVlFactor',
  tabIiH1VlPessoa: 'tabIiH1VlPessoa',
  tabIiH2VlCorp: 'tabIiH2VlCorp',
  tabIiIVlSetorPublico: 'tabIiIVlSetorPublico',
  tabIiI1VlPrecat: 'tabIiI1VlPrecat',
  tabIiI2VlTribut: 'tabIiI2VlTribut',
  tabIiI3VlRoyalties: 'tabIiI3VlRoyalties',
  tabIiI4VlOutro: 'tabIiI4VlOutro',
  tabIiJVlJudicial: 'tabIiJVlJudicial',
  tabIiKVlMarca: 'tabIiKVlMarca',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabIiScalarFieldEnum = (typeof CvmFidcInfMensalTabIiScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabIiScalarFieldEnum]


export const CvmFidcInfMensalTabIvScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabIvAVlPl: 'tabIvAVlPl',
  tabIvBVlPlMedio: 'tabIvBVlPlMedio',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabIvScalarFieldEnum = (typeof CvmFidcInfMensalTabIvScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabIvScalarFieldEnum]


export const CvmFidcInfMensalTabIxScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabIxA111CompraMin: 'tabIxA111CompraMin',
  tabIxA112CompraMedia: 'tabIxA112CompraMedia',
  tabIxA113CompraMax: 'tabIxA113CompraMax',
  tabIxA121VendaMin: 'tabIxA121VendaMin',
  tabIxA122VendaMedia: 'tabIxA122VendaMedia',
  tabIxA123VendaMax: 'tabIxA123VendaMax',
  tabIxA211CompraMin: 'tabIxA211CompraMin',
  tabIxA212CompraMedia: 'tabIxA212CompraMedia',
  tabIxA213CompraMax: 'tabIxA213CompraMax',
  tabIxA221VendaMin: 'tabIxA221VendaMin',
  tabIxA222VendaMedia: 'tabIxA222VendaMedia',
  tabIxA223VendaMax: 'tabIxA223VendaMax',
  tabIxB111CompraMin: 'tabIxB111CompraMin',
  tabIxB112CompraMedia: 'tabIxB112CompraMedia',
  tabIxB113CompraMax: 'tabIxB113CompraMax',
  tabIxB121VendaMin: 'tabIxB121VendaMin',
  tabIxB122VendaMedia: 'tabIxB122VendaMedia',
  tabIxB123VendaMax: 'tabIxB123VendaMax',
  tabIxB211CompraMin: 'tabIxB211CompraMin',
  tabIxB212CompraMedia: 'tabIxB212CompraMedia',
  tabIxB213CompraMax: 'tabIxB213CompraMax',
  tabIxB221VendaMin: 'tabIxB221VendaMin',
  tabIxB222VendaMedia: 'tabIxB222VendaMedia',
  tabIxB223VendaMax: 'tabIxB223VendaMax',
  tabIxC111CompraMin: 'tabIxC111CompraMin',
  tabIxC112CompraMedia: 'tabIxC112CompraMedia',
  tabIxC113CompraMax: 'tabIxC113CompraMax',
  tabIxC121VendaMin: 'tabIxC121VendaMin',
  tabIxC122VendaMedia: 'tabIxC122VendaMedia',
  tabIxC123VendaMax: 'tabIxC123VendaMax',
  tabIxC211CompraMin: 'tabIxC211CompraMin',
  tabIxC212CompraMedia: 'tabIxC212CompraMedia',
  tabIxC213CompraMax: 'tabIxC213CompraMax',
  tabIxC221VendaMin: 'tabIxC221VendaMin',
  tabIxC222VendaMedia: 'tabIxC222VendaMedia',
  tabIxC223VendaMax: 'tabIxC223VendaMax',
  tabIxD111CompraMin: 'tabIxD111CompraMin',
  tabIxD112CompraMedia: 'tabIxD112CompraMedia',
  tabIxD113CompraMax: 'tabIxD113CompraMax',
  tabIxD121VendaMin: 'tabIxD121VendaMin',
  tabIxD122VendaMedia: 'tabIxD122VendaMedia',
  tabIxD123VendaMax: 'tabIxD123VendaMax',
  tabIxD211CompraMin: 'tabIxD211CompraMin',
  tabIxD212CompraMedia: 'tabIxD212CompraMedia',
  tabIxD213CompraMax: 'tabIxD213CompraMax',
  tabIxD221VendaMin: 'tabIxD221VendaMin',
  tabIxD222VendaMedia: 'tabIxD222VendaMedia',
  tabIxD223VendaMax: 'tabIxD223VendaMax',
  tabIxE111CompraMin: 'tabIxE111CompraMin',
  tabIxE112CompraMedia: 'tabIxE112CompraMedia',
  tabIxE113CompraMax: 'tabIxE113CompraMax',
  tabIxE121VendaMin: 'tabIxE121VendaMin',
  tabIxE122VendaMedia: 'tabIxE122VendaMedia',
  tabIxE123VendaMax: 'tabIxE123VendaMax',
  tabIxE211CompraMin: 'tabIxE211CompraMin',
  tabIxE212CompraMedia: 'tabIxE212CompraMedia',
  tabIxE213CompraMax: 'tabIxE213CompraMax',
  tabIxE221VendaMin: 'tabIxE221VendaMin',
  tabIxE222VendaMedia: 'tabIxE222VendaMedia',
  tabIxE223VendaMax: 'tabIxE223VendaMax',
  tabIxF111CompraMin: 'tabIxF111CompraMin',
  tabIxF112CompraMedia: 'tabIxF112CompraMedia',
  tabIxF113CompraMax: 'tabIxF113CompraMax',
  tabIxF121VendaMin: 'tabIxF121VendaMin',
  tabIxF122VendaMedia: 'tabIxF122VendaMedia',
  tabIxF123VendaMax: 'tabIxF123VendaMax',
  tabIxF211CompraMin: 'tabIxF211CompraMin',
  tabIxF212CompraMedia: 'tabIxF212CompraMedia',
  tabIxF213CompraMax: 'tabIxF213CompraMax',
  tabIxF221VendaMin: 'tabIxF221VendaMin',
  tabIxF222VendaMedia: 'tabIxF222VendaMedia',
  tabIxF223VendaMax: 'tabIxF223VendaMax',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabIxScalarFieldEnum = (typeof CvmFidcInfMensalTabIxScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabIxScalarFieldEnum]


export const CvmFidcInfMensalTabIScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  classeUnica: 'classeUnica',
  cnpjAdmin: 'cnpjAdmin',
  admin: 'admin',
  classe: 'classe',
  cnpjClasse: 'cnpjClasse',
  condom: 'condom',
  fundoExclusivo: 'fundoExclusivo',
  cotstInteresse: 'cotstInteresse',
  prazoConversaoCota: 'prazoConversaoCota',
  tpPrazoConversaoCota: 'tpPrazoConversaoCota',
  prazoPagtoResgate: 'prazoPagtoResgate',
  tpPrazoPagtoResgate: 'tpPrazoPagtoResgate',
  tabIVlAtivo: 'tabIVlAtivo',
  tabI1VlDisp: 'tabI1VlDisp',
  tabI2VlCarteira: 'tabI2VlCarteira',
  tabI2AVlDircredRisco: 'tabI2AVlDircredRisco',
  tabI2A1VlCredVencAd: 'tabI2A1VlCredVencAd',
  tabI2A2VlCredVencInad: 'tabI2A2VlCredVencInad',
  tabI2A21VlTotalParcelaInad: 'tabI2A21VlTotalParcelaInad',
  tabI2A3VlCredInad: 'tabI2A3VlCredInad',
  tabI2A4VlCredDircredPerfm: 'tabI2A4VlCredDircredPerfm',
  tabI2A5VlCredVencidoPendente: 'tabI2A5VlCredVencidoPendente',
  tabI2A6VlCredEmpRecup: 'tabI2A6VlCredEmpRecup',
  tabI2A7VlCredReceitaPublica: 'tabI2A7VlCredReceitaPublica',
  tabI2A8VlCredAcaoJudic: 'tabI2A8VlCredAcaoJudic',
  tabI2A9VlCredFatorRisco: 'tabI2A9VlCredFatorRisco',
  tabI2A10VlCredDiverso: 'tabI2A10VlCredDiverso',
  tabI2A11VlReducaoRecup: 'tabI2A11VlReducaoRecup',
  tabI2A12CpfCnpjCedente1: 'tabI2A12CpfCnpjCedente1',
  tabI2A12PrCedente1: 'tabI2A12PrCedente1',
  tabI2A12CpfCnpjCedente2: 'tabI2A12CpfCnpjCedente2',
  tabI2A12PrCedente2: 'tabI2A12PrCedente2',
  tabI2A12CpfCnpjCedente3: 'tabI2A12CpfCnpjCedente3',
  tabI2A12PrCedente3: 'tabI2A12PrCedente3',
  tabI2A12CpfCnpjCedente4: 'tabI2A12CpfCnpjCedente4',
  tabI2A12PrCedente4: 'tabI2A12PrCedente4',
  tabI2A12CpfCnpjCedente5: 'tabI2A12CpfCnpjCedente5',
  tabI2A12PrCedente5: 'tabI2A12PrCedente5',
  tabI2A12CpfCnpjCedente6: 'tabI2A12CpfCnpjCedente6',
  tabI2A12PrCedente6: 'tabI2A12PrCedente6',
  tabI2A12CpfCnpjCedente7: 'tabI2A12CpfCnpjCedente7',
  tabI2A12PrCedente7: 'tabI2A12PrCedente7',
  tabI2A12CpfCnpjCedente8: 'tabI2A12CpfCnpjCedente8',
  tabI2A12PrCedente8: 'tabI2A12PrCedente8',
  tabI2A12CpfCnpjCedente9: 'tabI2A12CpfCnpjCedente9',
  tabI2A12PrCedente9: 'tabI2A12PrCedente9',
  tabI2BVlDircredSemRisco: 'tabI2BVlDircredSemRisco',
  tabI2B1VlCredVencAd: 'tabI2B1VlCredVencAd',
  tabI2B2VlCredVencInad: 'tabI2B2VlCredVencInad',
  tabI2B21VlTotalParcelaInad: 'tabI2B21VlTotalParcelaInad',
  tabI2B3VlCredInad: 'tabI2B3VlCredInad',
  tabI2B4VlCredDircredPerfm: 'tabI2B4VlCredDircredPerfm',
  tabI2B5VlCredVencidoPendente: 'tabI2B5VlCredVencidoPendente',
  tabI2B6VlCredEmpRecup: 'tabI2B6VlCredEmpRecup',
  tabI2B7VlCredReceitaPublica: 'tabI2B7VlCredReceitaPublica',
  tabI2B8VlCredAcaoJudic: 'tabI2B8VlCredAcaoJudic',
  tabI2B9VlCredFatorRisco: 'tabI2B9VlCredFatorRisco',
  tabI2B10VlCredDiverso: 'tabI2B10VlCredDiverso',
  tabI2B11VlReducaoRecup: 'tabI2B11VlReducaoRecup',
  tabI2B12CpfCnpjCedente1: 'tabI2B12CpfCnpjCedente1',
  tabI2B12PrCedente1: 'tabI2B12PrCedente1',
  tabI2B12CpfCnpjCedente2: 'tabI2B12CpfCnpjCedente2',
  tabI2B12PrCedente2: 'tabI2B12PrCedente2',
  tabI2B12CpfCnpjCedente3: 'tabI2B12CpfCnpjCedente3',
  tabI2B12PrCedente3: 'tabI2B12PrCedente3',
  tabI2B12CpfCnpjCedente4: 'tabI2B12CpfCnpjCedente4',
  tabI2B12PrCedente4: 'tabI2B12PrCedente4',
  tabI2B12CpfCnpjCedente5: 'tabI2B12CpfCnpjCedente5',
  tabI2B12PrCedente5: 'tabI2B12PrCedente5',
  tabI2B12CpfCnpjCedente6: 'tabI2B12CpfCnpjCedente6',
  tabI2B12PrCedente6: 'tabI2B12PrCedente6',
  tabI2B12CpfCnpjCedente7: 'tabI2B12CpfCnpjCedente7',
  tabI2B12PrCedente7: 'tabI2B12PrCedente7',
  tabI2B12CpfCnpjCedente8: 'tabI2B12CpfCnpjCedente8',
  tabI2B12PrCedente8: 'tabI2B12PrCedente8',
  tabI2B12CpfCnpjCedente9: 'tabI2B12CpfCnpjCedente9',
  tabI2B12PrCedente9: 'tabI2B12PrCedente9',
  tabI2CVlVlmob: 'tabI2CVlVlmob',
  tabI2C1VlDebenture: 'tabI2C1VlDebenture',
  tabI2C2VlCri: 'tabI2C2VlCri',
  tabI2C3VlNpComerc: 'tabI2C3VlNpComerc',
  tabI2C4VlLetraFinanc: 'tabI2C4VlLetraFinanc',
  tabI2C5VlCotaFundoIcvm555: 'tabI2C5VlCotaFundoIcvm555',
  tabI2C5VlCotaFif: 'tabI2C5VlCotaFif',
  tabI2C6VlOutro: 'tabI2C6VlOutro',
  tabI2DVlTitpubFed: 'tabI2DVlTitpubFed',
  tabI2EVlCdb: 'tabI2EVlCdb',
  tabI2FVlOperComprom: 'tabI2FVlOperComprom',
  tabI2GVlOutroRf: 'tabI2GVlOutroRf',
  tabI2HVlCotaFidc: 'tabI2HVlCotaFidc',
  tabI2IVlCotaFidcNp: 'tabI2IVlCotaFidcNp',
  tabI2JVlContratoFuturo: 'tabI2JVlContratoFuturo',
  tabI2DebentureCri: 'tabI2DebentureCri',
  tabI2CotaFidc: 'tabI2CotaFidc',
  tabI2VlOutroAtivo: 'tabI2VlOutroAtivo',
  tabI3VlPosicaoDeriv: 'tabI3VlPosicaoDeriv',
  tabI3AVlMercadoTermo: 'tabI3AVlMercadoTermo',
  tabI3BVlMercadoOpcao: 'tabI3BVlMercadoOpcao',
  tabI3CVlMercadoFuturo: 'tabI3CVlMercadoFuturo',
  tabI3DVlDiferSwap: 'tabI3DVlDiferSwap',
  tabI3EVlCobertura: 'tabI3EVlCobertura',
  tabI3FVlDepositoMargem: 'tabI3FVlDepositoMargem',
  tabI4VlOutroAtivo: 'tabI4VlOutroAtivo',
  tabI4AVlCprazo: 'tabI4AVlCprazo',
  tabI4BVlLprazo: 'tabI4BVlLprazo',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabIScalarFieldEnum = (typeof CvmFidcInfMensalTabIScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabIScalarFieldEnum]


export const CvmFidcInfMensalTabViiScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabViiA11QtDircredRisco: 'tabViiA11QtDircredRisco',
  tabViiA12VlDircredRisco: 'tabViiA12VlDircredRisco',
  tabViiA21QtDircredSemRisco: 'tabViiA21QtDircredSemRisco',
  tabViiA22VlDircredSemRisco: 'tabViiA22VlDircredSemRisco',
  tabViiA31QtDircredVencAd: 'tabViiA31QtDircredVencAd',
  tabViiA32VlDircredVencAd: 'tabViiA32VlDircredVencAd',
  tabViiA41QtDircredVencInad: 'tabViiA41QtDircredVencInad',
  tabViiA42VlDircredVencInad: 'tabViiA42VlDircredVencInad',
  tabViiA51QtDircredInad: 'tabViiA51QtDircredInad',
  tabViiA52VlDircredInad: 'tabViiA52VlDircredInad',
  tabViiB11QtCedente: 'tabViiB11QtCedente',
  tabViiB12VlCedente: 'tabViiB12VlCedente',
  tabViiB13VlContabCedente: 'tabViiB13VlContabCedente',
  tabViiB21QtPrest: 'tabViiB21QtPrest',
  tabViiB22VlPrest: 'tabViiB22VlPrest',
  tabViiB23VlContabPrest: 'tabViiB23VlContabPrest',
  tabViiB31QtTerceiro: 'tabViiB31QtTerceiro',
  tabViiB32VlTerceiro: 'tabViiB32VlTerceiro',
  tabViiB33VlContabTerceiro: 'tabViiB33VlContabTerceiro',
  tabViiC1QtSubst: 'tabViiC1QtSubst',
  tabViiC2VlSubst: 'tabViiC2VlSubst',
  tabViiC3VlContabSubst: 'tabViiC3VlContabSubst',
  tabViiD1QtRecompra: 'tabViiD1QtRecompra',
  tabViiD2VlRecompra: 'tabViiD2VlRecompra',
  tabViiD3VlContabRecompra: 'tabViiD3VlContabRecompra',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabViiScalarFieldEnum = (typeof CvmFidcInfMensalTabViiScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabViiScalarFieldEnum]


export const CvmFidcInfMensalTabViiiScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  sequencial: 'sequencial',
  valor: 'valor',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabViiiScalarFieldEnum = (typeof CvmFidcInfMensalTabViiiScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabViiiScalarFieldEnum]


export const CvmFidcInfMensalTabViScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabViAVlDircredPrazo: 'tabViAVlDircredPrazo',
  tabViA1VlPrazoVenc30: 'tabViA1VlPrazoVenc30',
  tabViA2VlPrazoVenc60: 'tabViA2VlPrazoVenc60',
  tabViA3VlPrazoVenc90: 'tabViA3VlPrazoVenc90',
  tabViA4VlPrazoVenc120: 'tabViA4VlPrazoVenc120',
  tabViA5VlPrazoVenc150: 'tabViA5VlPrazoVenc150',
  tabViA6VlPrazoVenc180: 'tabViA6VlPrazoVenc180',
  tabViA7VlPrazoVenc360: 'tabViA7VlPrazoVenc360',
  tabViA8VlPrazoVenc720: 'tabViA8VlPrazoVenc720',
  tabViA9VlPrazoVenc1080: 'tabViA9VlPrazoVenc1080',
  tabViA10VlPrazoVencMaior1080: 'tabViA10VlPrazoVencMaior1080',
  tabViBVlDircredInad: 'tabViBVlDircredInad',
  tabViB1VlInad30: 'tabViB1VlInad30',
  tabViB2VlInad60: 'tabViB2VlInad60',
  tabViB3VlInad90: 'tabViB3VlInad90',
  tabViB4VlInad120: 'tabViB4VlInad120',
  tabViB5VlInad150: 'tabViB5VlInad150',
  tabViB6VlInad180: 'tabViB6VlInad180',
  tabViB7VlInad360: 'tabViB7VlInad360',
  tabViB8VlInad720: 'tabViB8VlInad720',
  tabViB9VlInad1080: 'tabViB9VlInad1080',
  tabViB10VlInadMaior1080: 'tabViB10VlInadMaior1080',
  tabViCVlDircredAntecipado: 'tabViCVlDircredAntecipado',
  tabViC1VlAntecipado30: 'tabViC1VlAntecipado30',
  tabViC2VlAntecipado60: 'tabViC2VlAntecipado60',
  tabViC3VlAntecipado90: 'tabViC3VlAntecipado90',
  tabViC4VlAntecipado120: 'tabViC4VlAntecipado120',
  tabViC5VlAntecipado150: 'tabViC5VlAntecipado150',
  tabViC6VlAntecipado180: 'tabViC6VlAntecipado180',
  tabViC7VlAntecipado360: 'tabViC7VlAntecipado360',
  tabViC8VlAntecipado720: 'tabViC8VlAntecipado720',
  tabViC9VlAntecipado1080: 'tabViC9VlAntecipado1080',
  tabViC10VlAntecipadoMaior1080: 'tabViC10VlAntecipadoMaior1080',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabViScalarFieldEnum = (typeof CvmFidcInfMensalTabViScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabViScalarFieldEnum]


export const CvmFidcInfMensalTabVScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabVAVlDircredPrazo: 'tabVAVlDircredPrazo',
  tabVA1VlPrazoVenc30: 'tabVA1VlPrazoVenc30',
  tabVA2VlPrazoVenc60: 'tabVA2VlPrazoVenc60',
  tabVA3VlPrazoVenc90: 'tabVA3VlPrazoVenc90',
  tabVA4VlPrazoVenc120: 'tabVA4VlPrazoVenc120',
  tabVA5VlPrazoVenc150: 'tabVA5VlPrazoVenc150',
  tabVA6VlPrazoVenc180: 'tabVA6VlPrazoVenc180',
  tabVA7VlPrazoVenc360: 'tabVA7VlPrazoVenc360',
  tabVA8VlPrazoVenc720: 'tabVA8VlPrazoVenc720',
  tabVA9VlPrazoVenc1080: 'tabVA9VlPrazoVenc1080',
  tabVA10VlPrazoVencMaior1080: 'tabVA10VlPrazoVencMaior1080',
  tabVBVlDircredInad: 'tabVBVlDircredInad',
  tabVB1VlInad30: 'tabVB1VlInad30',
  tabVB2VlInad60: 'tabVB2VlInad60',
  tabVB3VlInad90: 'tabVB3VlInad90',
  tabVB4VlInad120: 'tabVB4VlInad120',
  tabVB5VlInad150: 'tabVB5VlInad150',
  tabVB6VlInad180: 'tabVB6VlInad180',
  tabVB7VlInad360: 'tabVB7VlInad360',
  tabVB8VlInad720: 'tabVB8VlInad720',
  tabVB9VlInad1080: 'tabVB9VlInad1080',
  tabVB10VlInadMaior1080: 'tabVB10VlInadMaior1080',
  tabVCVlDircredAntecipado: 'tabVCVlDircredAntecipado',
  tabVC1VlAntecipado30: 'tabVC1VlAntecipado30',
  tabVC2VlAntecipado60: 'tabVC2VlAntecipado60',
  tabVC3VlAntecipado90: 'tabVC3VlAntecipado90',
  tabVC4VlAntecipado120: 'tabVC4VlAntecipado120',
  tabVC5VlAntecipado150: 'tabVC5VlAntecipado150',
  tabVC6VlAntecipado180: 'tabVC6VlAntecipado180',
  tabVC7VlAntecipado360: 'tabVC7VlAntecipado360',
  tabVC8VlAntecipado720: 'tabVC8VlAntecipado720',
  tabVC9VlAntecipado1080: 'tabVC9VlAntecipado1080',
  tabVC10VlAntecipadoMaior1080: 'tabVC10VlAntecipadoMaior1080',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabVScalarFieldEnum = (typeof CvmFidcInfMensalTabVScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabVScalarFieldEnum]


export const CvmFidcInfMensalTabX11ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXNrCotstSeniorPf: 'tabXNrCotstSeniorPf',
  tabXNrCotstSeniorPjNaoFinanc: 'tabXNrCotstSeniorPjNaoFinanc',
  tabXNrCotstSeniorBanco: 'tabXNrCotstSeniorBanco',
  tabXNrCotstSeniorCorretoraDistrib: 'tabXNrCotstSeniorCorretoraDistrib',
  tabXNrCotstSeniorPjFinanc: 'tabXNrCotstSeniorPjFinanc',
  tabXNrCotstSeniorInvnr: 'tabXNrCotstSeniorInvnr',
  tabXNrCotstSeniorEapc: 'tabXNrCotstSeniorEapc',
  tabXNrCotstSeniorEfpc: 'tabXNrCotstSeniorEfpc',
  tabXNrCotstSeniorRpps: 'tabXNrCotstSeniorRpps',
  tabXNrCotstSeniorSegur: 'tabXNrCotstSeniorSegur',
  tabXNrCotstSeniorCapitaliz: 'tabXNrCotstSeniorCapitaliz',
  tabXNrCotstSeniorCotaFidc: 'tabXNrCotstSeniorCotaFidc',
  tabXNrCotstSeniorFii: 'tabXNrCotstSeniorFii',
  tabXNrCotstSeniorOutroFi: 'tabXNrCotstSeniorOutroFi',
  tabXNrCotstSeniorClube: 'tabXNrCotstSeniorClube',
  tabXNrCotstSeniorOutro: 'tabXNrCotstSeniorOutro',
  tabXNrCotstSubordPf: 'tabXNrCotstSubordPf',
  tabXNrCotstSubordPjNaoFinanc: 'tabXNrCotstSubordPjNaoFinanc',
  tabXNrCotstSubordBanco: 'tabXNrCotstSubordBanco',
  tabXNrCotstSubordCorretoraDistrib: 'tabXNrCotstSubordCorretoraDistrib',
  tabXNrCotstSubordPjFinanc: 'tabXNrCotstSubordPjFinanc',
  tabXNrCotstSubordInvnr: 'tabXNrCotstSubordInvnr',
  tabXNrCotstSubordEapc: 'tabXNrCotstSubordEapc',
  tabXNrCotstSubordEfpc: 'tabXNrCotstSubordEfpc',
  tabXNrCotstSubordRpps: 'tabXNrCotstSubordRpps',
  tabXNrCotstSubordSegur: 'tabXNrCotstSubordSegur',
  tabXNrCotstSubordCapitaliz: 'tabXNrCotstSubordCapitaliz',
  tabXNrCotstSubordCotaFidc: 'tabXNrCotstSubordCotaFidc',
  tabXNrCotstSubordFii: 'tabXNrCotstSubordFii',
  tabXNrCotstSubordOutroFi: 'tabXNrCotstSubordOutroFi',
  tabXNrCotstSubordClube: 'tabXNrCotstSubordClube',
  tabXNrCotstSubordOutro: 'tabXNrCotstSubordOutro',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX11ScalarFieldEnum = (typeof CvmFidcInfMensalTabX11ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX11ScalarFieldEnum]


export const CvmFidcInfMensalTabX1ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXClasseSerie: 'tabXClasseSerie',
  idSubclasse: 'idSubclasse',
  tabXNrCotst: 'tabXNrCotst',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX1ScalarFieldEnum = (typeof CvmFidcInfMensalTabX1ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX1ScalarFieldEnum]


export const CvmFidcInfMensalTabXScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXScrRiscoDevedorAa: 'tabXScrRiscoDevedorAa',
  tabXScrRiscoDevedorA: 'tabXScrRiscoDevedorA',
  tabXScrRiscoDevedorB: 'tabXScrRiscoDevedorB',
  tabXScrRiscoDevedorC: 'tabXScrRiscoDevedorC',
  tabXScrRiscoDevedorD: 'tabXScrRiscoDevedorD',
  tabXScrRiscoDevedorE: 'tabXScrRiscoDevedorE',
  tabXScrRiscoDevedorF: 'tabXScrRiscoDevedorF',
  tabXScrRiscoDevedorG: 'tabXScrRiscoDevedorG',
  tabXScrRiscoDevedorH: 'tabXScrRiscoDevedorH',
  tabXScrRiscoOperAa: 'tabXScrRiscoOperAa',
  tabXScrRiscoOperA: 'tabXScrRiscoOperA',
  tabXScrRiscoOperB: 'tabXScrRiscoOperB',
  tabXScrRiscoOperC: 'tabXScrRiscoOperC',
  tabXScrRiscoOperD: 'tabXScrRiscoOperD',
  tabXScrRiscoOperE: 'tabXScrRiscoOperE',
  tabXScrRiscoOperF: 'tabXScrRiscoOperF',
  tabXScrRiscoOperG: 'tabXScrRiscoOperG',
  tabXScrRiscoOperH: 'tabXScrRiscoOperH',
  tabXDebitoTribut: 'tabXDebitoTribut',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabXScalarFieldEnum = (typeof CvmFidcInfMensalTabXScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabXScalarFieldEnum]


export const CvmFidcInfMensalTabX2ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXClasseSerie: 'tabXClasseSerie',
  tabXQtCota: 'tabXQtCota',
  tabXVlCota: 'tabXVlCota',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX2ScalarFieldEnum = (typeof CvmFidcInfMensalTabX2ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX2ScalarFieldEnum]


export const CvmFidcInfMensalTabX3ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXClasseSerie: 'tabXClasseSerie',
  tabXVlRentabMes: 'tabXVlRentabMes',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX3ScalarFieldEnum = (typeof CvmFidcInfMensalTabX3ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX3ScalarFieldEnum]


export const CvmFidcInfMensalTabX4ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXTpOper: 'tabXTpOper',
  tabXClasseSerie: 'tabXClasseSerie',
  tabXVlTotal: 'tabXVlTotal',
  tabXQtCota: 'tabXQtCota',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX4ScalarFieldEnum = (typeof CvmFidcInfMensalTabX4ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX4ScalarFieldEnum]


export const CvmFidcInfMensalTabX5ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXVlLiquidez0: 'tabXVlLiquidez0',
  tabXVlLiquidez30: 'tabXVlLiquidez30',
  tabXVlLiquidez60: 'tabXVlLiquidez60',
  tabXVlLiquidez90: 'tabXVlLiquidez90',
  tabXVlLiquidez180: 'tabXVlLiquidez180',
  tabXVlLiquidez360: 'tabXVlLiquidez360',
  tabXVlLiquidezMaior360: 'tabXVlLiquidezMaior360',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX5ScalarFieldEnum = (typeof CvmFidcInfMensalTabX5ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX5ScalarFieldEnum]


export const CvmFidcInfMensalTabX6ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXClasseSerie: 'tabXClasseSerie',
  tabXPrDesempEsperado: 'tabXPrDesempEsperado',
  tabXPrDesempReal: 'tabXPrDesempReal',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX6ScalarFieldEnum = (typeof CvmFidcInfMensalTabX6ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX6ScalarFieldEnum]


export const CvmFidcInfMensalTabX7ScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  tabXVlGarantiaDircred: 'tabXVlGarantiaDircred',
  tabXPrGarantiaDircred: 'tabXPrGarantiaDircred',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFidcInfMensalTabX7ScalarFieldEnum = (typeof CvmFidcInfMensalTabX7ScalarFieldEnum)[keyof typeof CvmFidcInfMensalTabX7ScalarFieldEnum]


export const CvmFiagroInfMensalGeralScalarFieldEnum = {
  cnpjClasse: 'cnpjClasse',
  nomeClasse: 'nomeClasse',
  dataReferencia: 'dataReferencia',
  dataEntrega: 'dataEntrega',
  versao: 'versao',
  classeUnica: 'classeUnica',
  cnpjAdministrador: 'cnpjAdministrador',
  nomeAdministrador: 'nomeAdministrador',
  dataRegistro: 'dataRegistro',
  publicoAlvo: 'publicoAlvo',
  codigoIsin: 'codigoIsin',
  cotistasVinculoFamiliar: 'cotistasVinculoFamiliar',
  regraAnexo: 'regraAnexo',
  classificacaoAutorregulada: 'classificacaoAutorregulada',
  prazoDuracao: 'prazoDuracao',
  encerramentoExercicioSocial: 'encerramentoExercicioSocial',
  mercadoNegociacao: 'mercadoNegociacao',
  entidadeAdministradora: 'entidadeAdministradora',
  emailAdministrador: 'emailAdministrador',
  servicoAtendimentoCotista: 'servicoAtendimentoCotista',
  site: 'site',
  nomeGestor: 'nomeGestor',
  cnpjGestor: 'cnpjGestor',
  numeroCotistas: 'numeroCotistas',
  numeroCotistasPessoaNatural: 'numeroCotistasPessoaNatural',
  numeroCotistasPessoaJuridicaNaoFinanceira: 'numeroCotistasPessoaJuridicaNaoFinanceira',
  numeroCotistasPessoaJuridicaFinanceira: 'numeroCotistasPessoaJuridicaFinanceira',
  numeroCotistasInvestidorNaoResidente: 'numeroCotistasInvestidorNaoResidente',
  numeroCotistasEntidadePrevidenciaComplementarExcetoRpps: 'numeroCotistasEntidadePrevidenciaComplementarExcetoRpps',
  numeroCotistasEntidadeRpps: 'numeroCotistasEntidadeRpps',
  numeroCotistasSociedadeSeguradoraResseguradora: 'numeroCotistasSociedadeSeguradoraResseguradora',
  numeroCotistasFundosInvestimento: 'numeroCotistasFundosInvestimento',
  numeroCotistasDistribuidosContaOrdem: 'numeroCotistasDistribuidosContaOrdem',
  numeroCotistasOutrosTipos: 'numeroCotistasOutrosTipos',
  valorAtivo: 'valorAtivo',
  patrimonioLiquido: 'patrimonioLiquido',
  cotasEmitidas: 'cotasEmitidas',
  valorPatrimonialCotas: 'valorPatrimonialCotas',
  percentualDespesasTaxaAdministracao: 'percentualDespesasTaxaAdministracao',
  percentualDespesasTaxaGestao: 'percentualDespesasTaxaGestao',
  percentualDespesasTaxaDistribuicao: 'percentualDespesasTaxaDistribuicao',
  rentabilidadeEfetivaMes: 'rentabilidadeEfetivaMes',
  rentabilidadePatrimonialMes: 'rentabilidadePatrimonialMes',
  dividendYieldMes: 'dividendYieldMes',
  percentualAmortizacaoCotasMes: 'percentualAmortizacaoCotasMes',
  totalNecessidadesLiquidez: 'totalNecessidadesLiquidez',
  fundosRendaFixa: 'fundosRendaFixa',
  titulosRendaFixa: 'titulosRendaFixa',
  totalInvestido: 'totalInvestido',
  imoveisRurais: 'imoveisRurais',
  participacoesSocietarias: 'participacoesSocietarias',
  ativosFinanceirosLatoSensu: 'ativosFinanceirosLatoSensu',
  ativosFinanceiros: 'ativosFinanceiros',
  ativosFinanceirosEmissaoIf: 'ativosFinanceirosEmissaoIf',
  lca: 'lca',
  lci: 'lci',
  outrosAtivosEmissaoIf: 'outrosAtivosEmissaoIf',
  outrosAtivosFinanceiros: 'outrosAtivosFinanceiros',
  valoresMobiliarios: 'valoresMobiliarios',
  titulosParticipacoesSocietarias: 'titulosParticipacoesSocietarias',
  acoesCertificadosDeposito: 'acoesCertificadosDeposito',
  outrosTitulosParticipacao: 'outrosTitulosParticipacao',
  titulosDividaCorporativa: 'titulosDividaCorporativa',
  debentures: 'debentures',
  debenturesConversiveis: 'debenturesConversiveis',
  debenturesNaoConversiveis: 'debenturesNaoConversiveis',
  notasComerciais: 'notasComerciais',
  notasComerciaisCurtoPrazo: 'notasComerciaisCurtoPrazo',
  notasComerciaisLongoPrazo: 'notasComerciaisLongoPrazo',
  outrosTitulosDividaCorporativa: 'outrosTitulosDividaCorporativa',
  valorTitulosCredito: 'valorTitulosCredito',
  cpr: 'cpr',
  cprFinanceira: 'cprFinanceira',
  cprFisica: 'cprFisica',
  cdca: 'cdca',
  cdaWa: 'cdaWa',
  outrosTitulosCreditoAgronegocio: 'outrosTitulosCreditoAgronegocio',
  titulosCreditoLiquidacaoFinanceira: 'titulosCreditoLiquidacaoFinanceira',
  devedorPessoaJuridicaLiquidacaoFinanceira: 'devedorPessoaJuridicaLiquidacaoFinanceira',
  devedorPessoaNaturalLiquidacaoFinanceira: 'devedorPessoaNaturalLiquidacaoFinanceira',
  titulosCreditoLiquidacaoFisica: 'titulosCreditoLiquidacaoFisica',
  devedorPessoaJuridicaLiquidacaoFisica: 'devedorPessoaJuridicaLiquidacaoFisica',
  devedorPessoaNaturalLiquidacaoFisica: 'devedorPessoaNaturalLiquidacaoFisica',
  demaisDireitosCreditorios: 'demaisDireitosCreditorios',
  direitosCreditoriosAgronegocio: 'direitosCreditoriosAgronegocio',
  direitosCreditoriosImoveisRurais: 'direitosCreditoriosImoveisRurais',
  titulosSecuritizacao: 'titulosSecuritizacao',
  cra: 'cra',
  cri: 'cri',
  outrosTitulosSecuritizacao: 'outrosTitulosSecuritizacao',
  cotasFundosInvestimento: 'cotasFundosInvestimento',
  fif: 'fif',
  fidc: 'fidc',
  fii: 'fii',
  fip: 'fip',
  fiim: 'fiim',
  fiagro: 'fiagro',
  creditosCarbonoAgronegocio: 'creditosCarbonoAgronegocio',
  creditosDescarbonizacao: 'creditosDescarbonizacao',
  valoresReceber: 'valoresReceber',
  totalAtivosPrazoVencimento: 'totalAtivosPrazoVencimento',
  aVencer: 'aVencer',
  aVencerAte30Dias: 'aVencerAte30Dias',
  aVencer31a60Dias: 'aVencer31a60Dias',
  aVencer61a90Dias: 'aVencer61a90Dias',
  aVencer91a120Dias: 'aVencer91a120Dias',
  aVencer121a180Dias: 'aVencer121a180Dias',
  aVencer181a360Dias: 'aVencer181a360Dias',
  aVencer361a720Dias: 'aVencer361a720Dias',
  aVencer721a1080Dias: 'aVencer721a1080Dias',
  aVencerAcima1080Dias: 'aVencerAcima1080Dias',
  vencidos: 'vencidos',
  vencidosAte30Dias: 'vencidosAte30Dias',
  vencidos31a60Dias: 'vencidos31a60Dias',
  vencidos61a90Dias: 'vencidos61a90Dias',
  vencidos91a120Dias: 'vencidos91a120Dias',
  vencidos121a180Dias: 'vencidos121a180Dias',
  vencidos181a360Dias: 'vencidos181a360Dias',
  vencidos361a720Dias: 'vencidos361a720Dias',
  vencidos721a1080Dias: 'vencidos721a1080Dias',
  vencidosAcima1080Dias: 'vencidosAcima1080Dias',
  rendimentosDistribuir: 'rendimentosDistribuir',
  taxaAdministracaoPagar: 'taxaAdministracaoPagar',
  taxaGestaoPagar: 'taxaGestaoPagar',
  taxaPerformancePagar: 'taxaPerformancePagar',
  taxaDistribuicaoPagar: 'taxaDistribuicaoPagar',
  obrigacoesAquisicaoAtivos: 'obrigacoesAquisicaoAtivos',
  adiantamentoVendaAtivos: 'adiantamentoVendaAtivos',
  adiantamentoValoresReceber: 'adiantamentoValoresReceber',
  instrumentosFinanceirosDerivativos: 'instrumentosFinanceirosDerivativos',
  provisoesContigencias: 'provisoesContigencias',
  outrosValoresPagar: 'outrosValoresPagar',
  totalPassivo: 'totalPassivo',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiagroInfMensalGeralScalarFieldEnum = (typeof CvmFiagroInfMensalGeralScalarFieldEnum)[keyof typeof CvmFiagroInfMensalGeralScalarFieldEnum]


export const CvmFiagroInfMensalSubclasseScalarFieldEnum = {
  cnpjClasse: 'cnpjClasse',
  nomeClasse: 'nomeClasse',
  dataReferencia: 'dataReferencia',
  nomeSubclasse: 'nomeSubclasse',
  numeroCotas: 'numeroCotas',
  valorPatrimonialCota: 'valorPatrimonialCota',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFiagroInfMensalSubclasseScalarFieldEnum = (typeof CvmFiagroInfMensalSubclasseScalarFieldEnum)[keyof typeof CvmFiagroInfMensalSubclasseScalarFieldEnum]


export const CvmFipInfQuadrimestralScalarFieldEnum = {
  tpFundoClasse: 'tpFundoClasse',
  cnpjFundoClasse: 'cnpjFundoClasse',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  vlPatrimLiq: 'vlPatrimLiq',
  qtCota: 'qtCota',
  vlPatrimCota: 'vlPatrimCota',
  nrCotst: 'nrCotst',
  entidInvest: 'entidInvest',
  publicoAlvo: 'publicoAlvo',
  vlCapComprom: 'vlCapComprom',
  qtCotaSubscr: 'qtCotaSubscr',
  vlCapSubscr: 'vlCapSubscr',
  qtCotaIntegr: 'qtCotaIntegr',
  vlCapIntegr: 'vlCapIntegr',
  vlInvestFipCota: 'vlInvestFipCota',
  nrCotstSubscrPf: 'nrCotstSubscrPf',
  prCotaSubscrPf: 'prCotaSubscrPf',
  nrCotstSubscrPjNaoFinanc: 'nrCotstSubscrPjNaoFinanc',
  prCotaSubscrPjNaoFinanc: 'prCotaSubscrPjNaoFinanc',
  nrCotstSubscrBanco: 'nrCotstSubscrBanco',
  prCotaSubscrBanco: 'prCotaSubscrBanco',
  nrCotstSubscrCorretoraDistrib: 'nrCotstSubscrCorretoraDistrib',
  prCotaSubscrCorretoraDistrib: 'prCotaSubscrCorretoraDistrib',
  nrCotstSubscrPjFinanc: 'nrCotstSubscrPjFinanc',
  prCotaSubscrPjFinanc: 'prCotaSubscrPjFinanc',
  nrCotstSubscrInvnr: 'nrCotstSubscrInvnr',
  prCotaSubscrInvnr: 'prCotaSubscrInvnr',
  nrCotstSubscrEapc: 'nrCotstSubscrEapc',
  prCotaSubscrEapc: 'prCotaSubscrEapc',
  nrCotstSubscrEfpc: 'nrCotstSubscrEfpc',
  prCotaSubscrEfpc: 'prCotaSubscrEfpc',
  nrCotstSubscrRpps: 'nrCotstSubscrRpps',
  prCotaSubscrRpps: 'prCotaSubscrRpps',
  nrCotstSubscrSegur: 'nrCotstSubscrSegur',
  prCotaSubscrSegur: 'prCotaSubscrSegur',
  nrCotstSubscrCapitaliz: 'nrCotstSubscrCapitaliz',
  prCotaSubscrCapitaliz: 'prCotaSubscrCapitaliz',
  nrCotstSubscrFii: 'nrCotstSubscrFii',
  prCotaSubscrFii: 'prCotaSubscrFii',
  nrCotstSubscrFi: 'nrCotstSubscrFi',
  prCotaSubscrFi: 'prCotaSubscrFi',
  nrCotstSubscrDistrib: 'nrCotstSubscrDistrib',
  prCotaSubscrDistrib: 'prCotaSubscrDistrib',
  nrCotstSubscrOutro: 'nrCotstSubscrOutro',
  prCotaSubscrOutro: 'prCotaSubscrOutro',
  nrTotalCotstSubscr: 'nrTotalCotstSubscr',
  prTotalCotaSubscr: 'prTotalCotaSubscr',
  classeCota: 'classeCota',
  nrCotstSubscrClasse: 'nrCotstSubscrClasse',
  qtCotaSubscrClasse: 'qtCotaSubscrClasse',
  qtCotaIntegrClasse: 'qtCotaIntegrClasse',
  vlQuotaClasse: 'vlQuotaClasse',
  direitoPolitClasse: 'direitoPolitClasse',
  direitoEconClasse: 'direitoEconClasse',
  rowHash: 'rowHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFipInfQuadrimestralScalarFieldEnum = (typeof CvmFipInfQuadrimestralScalarFieldEnum)[keyof typeof CvmFipInfQuadrimestralScalarFieldEnum]


export const CvmFieMedidasMesScalarFieldEnum = {
  tpFundo: 'tpFundo',
  cnpjFundo: 'cnpjFundo',
  denomSocial: 'denomSocial',
  dtComptc: 'dtComptc',
  vlPatrimLiq: 'vlPatrimLiq',
  nrCotst: 'nrCotst',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CvmFieMedidasMesScalarFieldEnum = (typeof CvmFieMedidasMesScalarFieldEnum)[keyof typeof CvmFieMedidasMesScalarFieldEnum]


export const ReportScalarFieldEnum = {
  id: 'id',
  documentId: 'documentId',
  instrumentId: 'instrumentId',
  acronym: 'acronym',
  category: 'category',
  documentDescription: 'documentDescription',
  documentType: 'documentType',
  semanticType: 'semanticType',
  semanticTypeSource: 'semanticTypeSource',
  deliveryDate: 'deliveryDate',
  reportUrl: 'reportUrl',
  reportXmlUrl: 'reportXmlUrl',
  tradingName: 'tradingName',
  contentType: 'contentType',
  fetchedAt: 'fetchedAt'
} as const

export type ReportScalarFieldEnum = (typeof ReportScalarFieldEnum)[keyof typeof ReportScalarFieldEnum]


export const SummaryScalarFieldEnum = {
  reportId: 'reportId',
  resumo: 'resumo',
  sentimentoGeral: 'sentimentoGeral',
  createdAt: 'createdAt'
} as const

export type SummaryScalarFieldEnum = (typeof SummaryScalarFieldEnum)[keyof typeof SummaryScalarFieldEnum]


export const SummaryFIIScalarFieldEnum = {
  summaryId: 'summaryId',
  proventos: 'proventos',
  proventosSentimento: 'proventosSentimento',
  prospectSubscricao: 'prospectSubscricao',
  prospectSubscricaoSentimento: 'prospectSubscricaoSentimento',
  mudancasVacanciaInadimplencia: 'mudancasVacanciaInadimplencia',
  mudancasVacanciaInadimplenciaSentimento: 'mudancasVacanciaInadimplenciaSentimento'
} as const

export type SummaryFIIScalarFieldEnum = (typeof SummaryFIIScalarFieldEnum)[keyof typeof SummaryFIIScalarFieldEnum]


export const PriceHistoryScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  date: 'date',
  open: 'open',
  high: 'high',
  low: 'low',
  close: 'close',
  volume: 'volume',
  trades: 'trades',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PriceHistoryScalarFieldEnum = (typeof PriceHistoryScalarFieldEnum)[keyof typeof PriceHistoryScalarFieldEnum]


export const PriceHistoryAdjustedScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  date: 'date',
  open: 'open',
  high: 'high',
  low: 'low',
  close: 'close',
  splitFactorApplied: 'splitFactorApplied',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type PriceHistoryAdjustedScalarFieldEnum = (typeof PriceHistoryAdjustedScalarFieldEnum)[keyof typeof PriceHistoryAdjustedScalarFieldEnum]


export const MarketSeriesScalarFieldEnum = {
  id: 'id',
  symbol: 'symbol',
  date: 'date',
  value: 'value',
  source: 'source',
  frequency: 'frequency',
  unit: 'unit',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MarketSeriesScalarFieldEnum = (typeof MarketSeriesScalarFieldEnum)[keyof typeof MarketSeriesScalarFieldEnum]


export const VpSnapshotScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  competence: 'competence',
  patrimonioLiquido: 'patrimonioLiquido',
  cotasEmitidas: 'cotasEmitidas',
  vpPorCota: 'vpPorCota',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type VpSnapshotScalarFieldEnum = (typeof VpSnapshotScalarFieldEnum)[keyof typeof VpSnapshotScalarFieldEnum]


export const LiquiditySnapshotScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  competence: 'competence',
  numeroCotistas: 'numeroCotistas',
  liquidezDiaria30d: 'liquidezDiaria30d',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type LiquiditySnapshotScalarFieldEnum = (typeof LiquiditySnapshotScalarFieldEnum)[keyof typeof LiquiditySnapshotScalarFieldEnum]


export const ScreenerSnapshotScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  idFnet: 'idFnet',
  idCem: 'idCem',
  name: 'name',
  companyName: 'companyName',
  instrumentTypeId: 'instrumentTypeId',
  fundTypeSymbol: 'fundTypeSymbol',
  fundTypeDescription: 'fundTypeDescription',
  asOfDate: 'asOfDate',
  volatilityAnnualized21dPct: 'volatilityAnnualized21dPct',
  volatilityObservations: 'volatilityObservations',
  currentPvp: 'currentPvp',
  pvpHistAvg12m: 'pvpHistAvg12m',
  pvpHistPoints: 'pvpHistPoints',
  pvpDiscountToHistAvgPct: 'pvpDiscountToHistAvgPct',
  inadimplenciaPct: 'inadimplenciaPct',
  inadimplenciaCompetence: 'inadimplenciaCompetence',
  inadimplenciaAssetsCount: 'inadimplenciaAssetsCount',
  inadimplenciaBaseCount: 'inadimplenciaBaseCount',
  segmentoCvm: 'segmentoCvm',
  tipoGestaoCvm: 'tipoGestaoCvm',
  classificacaoCvm: 'classificacaoCvm',
  tijoloPct: 'tijoloPct',
  papelPct: 'papelPct',
  currentPrice: 'currentPrice',
  lastPriceDate: 'lastPriceDate',
  dy12mPct: 'dy12mPct',
  dividends12mAmount: 'dividends12mAmount',
  latestDividendAmount: 'latestDividendAmount',
  dyMesPct: 'dyMesPct',
  dyGrowth12mPct: 'dyGrowth12mPct',
  vacanciaPct: 'vacanciaPct',
  cashEquivalentPct: 'cashEquivalentPct',
  cashResultPlPct: 'cashResultPlPct',
  cashPressureMonths12m: 'cashPressureMonths12m',
  cashNetCurrent: 'cashNetCurrent',
  cashNetPrevious: 'cashNetPrevious',
  cashTrendStatus: 'cashTrendStatus',
  concentracaoTijoloPct: 'concentracaoTijoloPct',
  concentracaoPapelPct: 'concentracaoPapelPct',
  liquidezDiaria30d: 'liquidezDiaria30d',
  distanceTo12mHighPct: 'distanceTo12mHighPct',
  vpPerShareGrowth12mPct: 'vpPerShareGrowth12mPct',
  currentVpPerShare: 'currentVpPerShare',
  patrimonioLiquido: 'patrimonioLiquido',
  cotasEmitidas: 'cotasEmitidas',
  numeroCotistas: 'numeroCotistas',
  realEstateValue: 'realEstateValue',
  investedFundsValue: 'investedFundsValue',
  financialAssetsValue: 'financialAssetsValue',
  equityParticipationsValue: 'equityParticipationsValue',
  mixRealEstatePct: 'mixRealEstatePct',
  mixFundsPct: 'mixFundsPct',
  mixFinancialAssetsPct: 'mixFinancialAssetsPct',
  mixEquitiesPct: 'mixEquitiesPct',
  cashResourcesValue: 'cashResourcesValue',
  receivablesValue: 'receivablesValue',
  payablesValue: 'payablesValue',
  netLiquidityValue: 'netLiquidityValue',
  cashOverInvestedPct: 'cashOverInvestedPct',
  portfolioFinancialAssetsPct: 'portfolioFinancialAssetsPct',
  portfolioFundsPct: 'portfolioFundsPct',
  realEstateTotalAssets: 'realEstateTotalAssets',
  realEstateVacancyAvgPct: 'realEstateVacancyAvgPct',
  realEstateDelinquencyAvgPct: 'realEstateDelinquencyAvgPct',
  realEstateAssetsWithVacancyCount: 'realEstateAssetsWithVacancyCount',
  realEstateAssetsWithDelinquencyCount: 'realEstateAssetsWithDelinquencyCount',
  realEstateTypicalContractsPct: 'realEstateTypicalContractsPct',
  realEstateAtypicalContractsPct: 'realEstateAtypicalContractsPct',
  paperTop5ConcentrationPct: 'paperTop5ConcentrationPct',
  paperInflationExposurePct: 'paperInflationExposurePct',
  paperMaturityUpto12mPct: 'paperMaturityUpto12mPct',
  paperDominantIndexerLabel: 'paperDominantIndexerLabel',
  paperDominantIndexerPct: 'paperDominantIndexerPct',
  selicSensitivityScore: 'selicSensitivityScore',
  leverageIndexScore: 'leverageIndexScore',
  selicSensitivityLabel: 'selicSensitivityLabel',
  leverageIndexLabel: 'leverageIndexLabel',
  classificacaoAsOfDate: 'classificacaoAsOfDate',
  classificacaoSource: 'classificacaoSource',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScreenerSnapshotScalarFieldEnum = (typeof ScreenerSnapshotScalarFieldEnum)[keyof typeof ScreenerSnapshotScalarFieldEnum]


export const ScreenerSnapshotPositionScalarFieldEnum = {
  id: 'id',
  screenerSnapshotId: 'screenerSnapshotId',
  instrumentId: 'instrumentId',
  positionName: 'positionName',
  positionType: 'positionType',
  positionValue: 'positionValue',
  portfolioPercent: 'portfolioPercent',
  sourceBasis: 'sourceBasis',
  referenceDate: 'referenceDate',
  rankOrder: 'rankOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScreenerSnapshotPositionScalarFieldEnum = (typeof ScreenerSnapshotPositionScalarFieldEnum)[keyof typeof ScreenerSnapshotPositionScalarFieldEnum]


export const ScreenerSnapshotRelatedScalarFieldEnum = {
  id: 'id',
  screenerSnapshotId: 'screenerSnapshotId',
  instrumentId: 'instrumentId',
  relatedInstrumentId: 'relatedInstrumentId',
  similarityScore: 'similarityScore',
  rankOrder: 'rankOrder',
  referenceDate: 'referenceDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ScreenerSnapshotRelatedScalarFieldEnum = (typeof ScreenerSnapshotRelatedScalarFieldEnum)[keyof typeof ScreenerSnapshotRelatedScalarFieldEnum]


export const AssetExposureDimensionScalarFieldEnum = {
  id: 'id',
  key: 'key',
  label: 'label',
  itemLabel: 'itemLabel',
  supportsItemCount: 'supportsItemCount',
  defaultDisplayMode: 'defaultDisplayMode',
  displayOrder: 'displayOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssetExposureDimensionScalarFieldEnum = (typeof AssetExposureDimensionScalarFieldEnum)[keyof typeof AssetExposureDimensionScalarFieldEnum]


export const AssetExposureValueScalarFieldEnum = {
  id: 'id',
  dimensionId: 'dimensionId',
  key: 'key',
  label: 'label',
  displayOrder: 'displayOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssetExposureValueScalarFieldEnum = (typeof AssetExposureValueScalarFieldEnum)[keyof typeof AssetExposureValueScalarFieldEnum]


export const AssetExposureProfileScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  dimensionId: 'dimensionId',
  availability: 'availability',
  coveragePct: 'coveragePct',
  mappedSourceItemCount: 'mappedSourceItemCount',
  totalSourceItemCount: 'totalSourceItemCount',
  sourceAsOf: 'sourceAsOf',
  source: 'source',
  calculatedAt: 'calculatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssetExposureProfileScalarFieldEnum = (typeof AssetExposureProfileScalarFieldEnum)[keyof typeof AssetExposureProfileScalarFieldEnum]


export const AssetExposureProfileItemScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  valueId: 'valueId',
  sourceItemKey: 'sourceItemKey',
  label: 'label',
  detail: 'detail',
  weightPct: 'weightPct',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssetExposureProfileItemScalarFieldEnum = (typeof AssetExposureProfileItemScalarFieldEnum)[keyof typeof AssetExposureProfileItemScalarFieldEnum]


export const AssetExposureProfileValueScalarFieldEnum = {
  id: 'id',
  profileId: 'profileId',
  valueId: 'valueId',
  weightPct: 'weightPct',
  sourceItemCount: 'sourceItemCount',
  sourceLabel: 'sourceLabel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AssetExposureProfileValueScalarFieldEnum = (typeof AssetExposureProfileValueScalarFieldEnum)[keyof typeof AssetExposureProfileValueScalarFieldEnum]


export const DividendScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  comDate: 'comDate',
  payDate: 'payDate',
  amountPerShare: 'amountPerShare',
  competence: 'competence',
  isinCode: 'isinCode',
  source: 'source',
  sourceEventLabel: 'sourceEventLabel',
  sourceEventType: 'sourceEventType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DividendScalarFieldEnum = (typeof DividendScalarFieldEnum)[keyof typeof DividendScalarFieldEnum]


export const DividendEventSnapshotScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  dividendId: 'dividendId',
  eventDate: 'eventDate',
  comDate: 'comDate',
  payDate: 'payDate',
  competence: 'competence',
  amountPerShareRaw: 'amountPerShareRaw',
  amountPerShareAdjusted: 'amountPerShareAdjusted',
  splitFactorApplied: 'splitFactorApplied',
  priceRefRaw: 'priceRefRaw',
  priceRefAdjusted: 'priceRefAdjusted',
  dyEventPct: 'dyEventPct',
  sourceEventType: 'sourceEventType',
  asFromDate: 'asFromDate',
  asOfDate: 'asOfDate',
  source: 'source',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DividendEventSnapshotScalarFieldEnum = (typeof DividendEventSnapshotScalarFieldEnum)[keyof typeof DividendEventSnapshotScalarFieldEnum]


export const CorporateActionScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  eventType: 'eventType',
  source: 'source',
  sourceEventId: 'sourceEventId',
  assetIssued: 'assetIssued',
  isinCode: 'isinCode',
  label: 'label',
  remarks: 'remarks',
  relatedTo: 'relatedTo',
  approvedOn: 'approvedOn',
  comDate: 'comDate',
  payDate: 'payDate',
  amountPerShare: 'amountPerShare',
  eventMagnitudeValue: 'eventMagnitudeValue',
  eventMagnitudeUnit: 'eventMagnitudeUnit',
  splitMultiplier: 'splitMultiplier',
  subscriptionPercentage: 'subscriptionPercentage',
  subscriptionPriceUnit: 'subscriptionPriceUnit',
  fetchedAt: 'fetchedAt',
  rawEvent: 'rawEvent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CorporateActionScalarFieldEnum = (typeof CorporateActionScalarFieldEnum)[keyof typeof CorporateActionScalarFieldEnum]


export const InstrumentSyncStateScalarFieldEnum = {
  id: 'id',
  instrumentId: 'instrumentId',
  lastPriceSyncAt: 'lastPriceSyncAt',
  lastVpSyncAt: 'lastVpSyncAt',
  lastLiquiditySyncAt: 'lastLiquiditySyncAt',
  lastDividendSyncAt: 'lastDividendSyncAt',
  lastScreenerSyncAt: 'lastScreenerSyncAt',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type InstrumentSyncStateScalarFieldEnum = (typeof InstrumentSyncStateScalarFieldEnum)[keyof typeof InstrumentSyncStateScalarFieldEnum]


export const MarketDataUrlStateScalarFieldEnum = {
  id: 'id',
  processor: 'processor',
  url: 'url',
  etag: 'etag',
  lastModified: 'lastModified',
  sha256: 'sha256',
  status: 'status',
  lastCheckedAt: 'lastCheckedAt',
  lastProcessedAt: 'lastProcessedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type MarketDataUrlStateScalarFieldEnum = (typeof MarketDataUrlStateScalarFieldEnum)[keyof typeof MarketDataUrlStateScalarFieldEnum]


export const PipelineRunScalarFieldEnum = {
  id: 'id',
  pipelineName: 'pipelineName',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  successCount: 'successCount',
  errorCount: 'errorCount',
  errorMessage: 'errorMessage'
} as const

export type PipelineRunScalarFieldEnum = (typeof PipelineRunScalarFieldEnum)[keyof typeof PipelineRunScalarFieldEnum]


export const PipelineStepRunScalarFieldEnum = {
  id: 'id',
  pipelineRunId: 'pipelineRunId',
  stepName: 'stepName',
  status: 'status',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  successCount: 'successCount',
  errorCount: 'errorCount',
  errorMessage: 'errorMessage'
} as const

export type PipelineStepRunScalarFieldEnum = (typeof PipelineStepRunScalarFieldEnum)[keyof typeof PipelineStepRunScalarFieldEnum]


export const EmailPreferenceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  reportType: 'reportType',
  scopeType: 'scopeType',
  scopeId: 'scopeId',
  enabled: 'enabled',
  frequencyDays: 'frequencyDays',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EmailPreferenceScalarFieldEnum = (typeof EmailPreferenceScalarFieldEnum)[keyof typeof EmailPreferenceScalarFieldEnum]


export const EmailProcessingStatusScalarFieldEnum = {
  preferenceId: 'preferenceId',
  lastEffectiveDate: 'lastEffectiveDate',
  lastProcessedAt: 'lastProcessedAt',
  lastStatus: 'lastStatus',
  sentCount: 'sentCount',
  clickedCount: 'clickedCount',
  lastClickedAt: 'lastClickedAt',
  errorMessage: 'errorMessage'
} as const

export type EmailProcessingStatusScalarFieldEnum = (typeof EmailProcessingStatusScalarFieldEnum)[keyof typeof EmailProcessingStatusScalarFieldEnum]


export const EmailCampaignScalarFieldEnum = {
  id: 'id',
  subject: 'subject',
  bodyMarkdown: 'bodyMarkdown',
  heroImageData: 'heroImageData',
  heroImageContentType: 'heroImageContentType',
  heroImageUpdatedAt: 'heroImageUpdatedAt',
  status: 'status',
  audience: 'audience',
  scheduledAt: 'scheduledAt',
  templateId: 'templateId',
  createdBy: 'createdBy',
  publishedAt: 'publishedAt',
  postwardSyncedAt: 'postwardSyncedAt',
  postwardSyncError: 'postwardSyncError',
  postwardCampaignId: 'postwardCampaignId',
  postwardSyncHash: 'postwardSyncHash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type EmailCampaignScalarFieldEnum = (typeof EmailCampaignScalarFieldEnum)[keyof typeof EmailCampaignScalarFieldEnum]


export const EmailCampaignStatusScalarFieldEnum = {
  preferenceId: 'preferenceId',
  campaignId: 'campaignId',
  status: 'status',
  processedAt: 'processedAt',
  clickedCount: 'clickedCount',
  lastClickedAt: 'lastClickedAt'
} as const

export type EmailCampaignStatusScalarFieldEnum = (typeof EmailCampaignStatusScalarFieldEnum)[keyof typeof EmailCampaignStatusScalarFieldEnum]


export const DmarcImporterStateScalarFieldEnum = {
  id: 'id',
  lastHighUid: 'lastHighUid',
  lastRunAt: 'lastRunAt',
  lastError: 'lastError',
  messagesSeen: 'messagesSeen',
  messagesParsed: 'messagesParsed',
  aggregateReports: 'aggregateReports',
  forensicReports: 'forensicReports',
  tlsRptReports: 'tlsRptReports',
  fblReports: 'fblReports'
} as const

export type DmarcImporterStateScalarFieldEnum = (typeof DmarcImporterStateScalarFieldEnum)[keyof typeof DmarcImporterStateScalarFieldEnum]


export const DmarcAggregateReportScalarFieldEnum = {
  id: 'id',
  orgName: 'orgName',
  email: 'email',
  reportId: 'reportId',
  beginAt: 'beginAt',
  endAt: 'endAt',
  domain: 'domain',
  adkim: 'adkim',
  aspf: 'aspf',
  policyP: 'policyP',
  policySp: 'policySp',
  policyPct: 'policyPct',
  policyNp: 'policyNp',
  rawXml: 'rawXml',
  receivedAt: 'receivedAt',
  messageUid: 'messageUid',
  sourceFile: 'sourceFile',
  parsedAt: 'parsedAt'
} as const

export type DmarcAggregateReportScalarFieldEnum = (typeof DmarcAggregateReportScalarFieldEnum)[keyof typeof DmarcAggregateReportScalarFieldEnum]


export const DmarcAggregateRecordScalarFieldEnum = {
  id: 'id',
  reportId: 'reportId',
  sourceIp: 'sourceIp',
  count: 'count',
  disposition: 'disposition',
  dkimResult: 'dkimResult',
  spfResult: 'spfResult',
  dkimDomain: 'dkimDomain',
  dkimSelector: 'dkimSelector',
  headerFrom: 'headerFrom',
  envelopeFrom: 'envelopeFrom',
  envelopeTo: 'envelopeTo'
} as const

export type DmarcAggregateRecordScalarFieldEnum = (typeof DmarcAggregateRecordScalarFieldEnum)[keyof typeof DmarcAggregateRecordScalarFieldEnum]


export const DmarcForensicReportScalarFieldEnum = {
  id: 'id',
  orgName: 'orgName',
  reportId: 'reportId',
  receivedAt: 'receivedAt',
  sourceIp: 'sourceIp',
  count: 'count',
  subject: 'subject',
  headersSample: 'headersSample',
  messageSample: 'messageSample',
  deliveryResult: 'deliveryResult',
  authFailure: 'authFailure',
  rawXml: 'rawXml',
  messageUid: 'messageUid'
} as const

export type DmarcForensicReportScalarFieldEnum = (typeof DmarcForensicReportScalarFieldEnum)[keyof typeof DmarcForensicReportScalarFieldEnum]


export const TlsRptReportScalarFieldEnum = {
  id: 'id',
  orgName: 'orgName',
  reportId: 'reportId',
  beginAt: 'beginAt',
  endAt: 'endAt',
  policyMode: 'policyMode',
  policyMx: 'policyMx',
  policyHttps: 'policyHttps',
  policySmtpTls: 'policySmtpTls',
  summaryTotalSuccess: 'summaryTotalSuccess',
  summaryTotalFailure: 'summaryTotalFailure',
  receivedAt: 'receivedAt',
  rawJson: 'rawJson',
  messageUid: 'messageUid'
} as const

export type TlsRptReportScalarFieldEnum = (typeof TlsRptReportScalarFieldEnum)[keyof typeof TlsRptReportScalarFieldEnum]


export const FblReportScalarFieldEnum = {
  id: 'id',
  source: 'source',
  userIp: 'userIp',
  reportedAt: 'reportedAt',
  receivedAt: 'receivedAt',
  feedbackType: 'feedbackType',
  headersSample: 'headersSample',
  rawJson: 'rawJson',
  messageUid: 'messageUid'
} as const

export type FblReportScalarFieldEnum = (typeof FblReportScalarFieldEnum)[keyof typeof FblReportScalarFieldEnum]


export const McpOAuthClientScalarFieldEnum = {
  id: 'id',
  name: 'name',
  redirectUris: 'redirectUris',
  createdAt: 'createdAt',
  lastUsedAt: 'lastUsedAt'
} as const

export type McpOAuthClientScalarFieldEnum = (typeof McpOAuthClientScalarFieldEnum)[keyof typeof McpOAuthClientScalarFieldEnum]


export const McpGrantScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  clientId: 'clientId',
  scope: 'scope',
  status: 'status',
  createdAt: 'createdAt',
  lastUsedAt: 'lastUsedAt',
  revokedAt: 'revokedAt'
} as const

export type McpGrantScalarFieldEnum = (typeof McpGrantScalarFieldEnum)[keyof typeof McpGrantScalarFieldEnum]


export const McpAuthCodeScalarFieldEnum = {
  codeHash: 'codeHash',
  userId: 'userId',
  clientId: 'clientId',
  scope: 'scope',
  codeChallenge: 'codeChallenge',
  resource: 'resource',
  redirectUri: 'redirectUri',
  expiresAt: 'expiresAt',
  consumedAt: 'consumedAt',
  createdAt: 'createdAt'
} as const

export type McpAuthCodeScalarFieldEnum = (typeof McpAuthCodeScalarFieldEnum)[keyof typeof McpAuthCodeScalarFieldEnum]


export const McpRefreshTokenScalarFieldEnum = {
  id: 'id',
  grantId: 'grantId',
  tokenHash: 'tokenHash',
  expiresAt: 'expiresAt',
  consumedAt: 'consumedAt',
  revokedAt: 'revokedAt',
  createdAt: 'createdAt'
} as const

export type McpRefreshTokenScalarFieldEnum = (typeof McpRefreshTokenScalarFieldEnum)[keyof typeof McpRefreshTokenScalarFieldEnum]


export const McpUsageLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  grantId: 'grantId',
  clientId: 'clientId',
  tool: 'tool',
  ok: 'ok',
  durationMs: 'durationMs',
  error: 'error',
  createdAt: 'createdAt'
} as const

export type McpUsageLogScalarFieldEnum = (typeof McpUsageLogScalarFieldEnum)[keyof typeof McpUsageLogScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

